import { Properties as Properties1 } from "csstype";

// This file is auto-generated by truss: https://github.com/homebound-team/truss.
// See your project's `truss-config.ts` to make configuration changes (fonts, increments, etc).

/** Given a type X, and the user's proposed type T, only allow keys in X and nothing else. */
export type Only<X, T> = X & Record<Exclude<keyof T, keyof X>, never>;

export type Properties = Properties1<string | 0, string>;

export type Typography = "t32" | "t24" | "t18" | "t16" | "t14" | "t12" | "t10";

type Opts<T> = { rules: T; enabled: boolean; important: boolean; selector: string | undefined };

class CssBuilder<T extends Properties> {
  constructor(private opts: Opts<T>) {}

  private get rules(): T {
    return this.opts.rules;
  }
  private get enabled(): boolean {
    return this.opts.enabled;
  }
  private get selector(): string | undefined {
    return this.opts.selector;
  }
  private newCss(opts: Partial<Opts<T>>): CssBuilder<T> {
    return new CssBuilder({ ...this.opts, ...opts });
  }

  // border
  /** Sets `borderStyle: "solid"; borderWidth: "1px"`. */
  get ba() {
    return this.add("borderStyle", "solid").add("borderWidth", "1px");
  }
  /** Sets `borderTopStyle: "solid"; borderTopWidth: "1px"`. */
  get bt() {
    return this.add("borderTopStyle", "solid").add("borderTopWidth", "1px");
  }
  /** Sets `borderRightStyle: "solid"; borderRightWidth: "1px"`. */
  get br() {
    return this.add("borderRightStyle", "solid").add("borderRightWidth", "1px");
  }
  /** Sets `borderBottomStyle: "solid"; borderBottomWidth: "1px"`. */
  get bb() {
    return this.add("borderBottomStyle", "solid").add("borderBottomWidth", "1px");
  }
  /** Sets `borderLeftStyle: "solid"; borderLeftWidth: "1px"`. */
  get bl() {
    return this.add("borderLeftStyle", "solid").add("borderLeftWidth", "1px");
  }
  /** Sets `borderStyle: "none"; borderWidth: "0"`. */
  get bn() {
    return this.add("borderStyle", "none").add("borderWidth", "0");
  }

  // borderColor
  /** Sets `borderColor: "#FFFFFF"`. */
  get bcWhite() {
    return this.add("borderColor", "#FFFFFF");
  }
  /** Sets `borderColor: "#F6F6F0"`. */
  get bcOffWhite() {
    return this.add("borderColor", "#F6F6F0");
  }
  /** Sets `borderColor: "#000000"`. */
  get bcBlack() {
    return this.add("borderColor", "#000000");
  }
  /** Sets `borderColor: "#0067C5"`. */
  get bcbpBlue() {
    return this.add("borderColor", "#0067C5");
  }
  /** Sets `borderColor: "#EBEAE4FF"`. */
  get bcTaupe() {
    return this.add("borderColor", "#EBEAE4FF");
  }
  /** Sets `borderColor: "#888888"`. */
  get bcGray() {
    return this.add("borderColor", "#888888");
  }
  /** Sets `borderColor: "#00000000"`. */
  get bcTransparent() {
    return this.add("borderColor", "#00000000");
  }
  /** Sets `borderColor: "#000000B2"`. */
  get bcTranslucentBlack() {
    return this.add("borderColor", "#000000B2");
  }
  /** Sets `borderColor: "#F6B14E"`. */
  get bcBrightYellow() {
    return this.add("borderColor", "#F6B14E");
  }
  /** Sets `borderColor: "#AEB564"`. */
  get bcBrightGreen() {
    return this.add("borderColor", "#AEB564");
  }
  /** Sets `borderColor: "#3A759D"`. */
  get bcBrightBlue() {
    return this.add("borderColor", "#3A759D");
  }
  /** Sets `borderColor: "#C86251"`. */
  get bcBrightStrawberry() {
    return this.add("borderColor", "#C86251");
  }
  /** Sets `borderColor: "#8B514E"`. */
  get bcSaturatedWine() {
    return this.add("borderColor", "#8B514E");
  }
  /** Sets `borderColor: "#D17520"`. */
  get bcSaturatedOrange() {
    return this.add("borderColor", "#D17520");
  }
  /** Sets `borderColor: "#657839"`. */
  get bcSaturatedGrass() {
    return this.add("borderColor", "#657839");
  }
  /** Sets `borderColor: "#9CA084"`. */
  get bcMoss() {
    return this.add("borderColor", "#9CA084");
  }
  /** Sets `borderColor: "#5F477F"`. */
  get bcPlum() {
    return this.add("borderColor", "#5F477F");
  }
  /** Sets `borderColor: "#CECECE"`. */
  get bcLightGray() {
    return this.add("borderColor", "#CECECE");
  }
  /** Sets `borderColor: "#66666DFF"`. */
  get bcMidGray() {
    return this.add("borderColor", "#66666DFF");
  }
  /** Sets `borderColor: "#D2D7DD"`. */
  get bcLightBlue() {
    return this.add("borderColor", "#D2D7DD");
  }
  /** Sets `borderColor: "#F7E9D5"`. */
  get bcLightPeach() {
    return this.add("borderColor", "#F7E9D5");
  }
  /** Sets `borderColor: "#353535CC"`. */
  get bcGray80() {
    return this.add("borderColor", "#353535CC");
  }
  /** Sets `borderColor: "#3535350A"`. */
  get bcGray4() {
    return this.add("borderColor", "#3535350A");
  }
  /** Sets `borderColor: "#35353514"`. */
  get bcGray8() {
    return this.add("borderColor", "#35353514");
  }
  /** Sets `borderColor: "#35353529"`. */
  get bcGray16() {
    return this.add("borderColor", "#35353529");
  }
  /** Sets `borderColor: "#fffdfd"`. */
  get bcGray50() {
    return this.add("borderColor", "#fffdfd");
  }
  /** Sets `borderColor: "#F7F5F5"`. */
  get bcGray100() {
    return this.add("borderColor", "#F7F5F5");
  }
  /** Sets `borderColor: "#ECEBEB"`. */
  get bcGray200() {
    return this.add("borderColor", "#ECEBEB");
  }
  /** Sets `borderColor: "#DDDCDC"`. */
  get bcGray300() {
    return this.add("borderColor", "#DDDCDC");
  }
  /** Sets `borderColor: "#C9C9C9"`. */
  get bcGray400() {
    return this.add("borderColor", "#C9C9C9");
  }
  /** Sets `borderColor: "#AFAFAF"`. */
  get bcGray500() {
    return this.add("borderColor", "#AFAFAF");
  }
  /** Sets `borderColor: "#8D8D8D"`. */
  get bcGray600() {
    return this.add("borderColor", "#8D8D8D");
  }
  /** Sets `borderColor: "#646464"`. */
  get bcGray700() {
    return this.add("borderColor", "#646464");
  }
  /** Sets `borderColor: "#353535"`. */
  get bcGray800() {
    return this.add("borderColor", "#353535");
  }
  /** Sets `borderColor: "#242424"`. */
  get bcGray900() {
    return this.add("borderColor", "#242424");
  }
  /** Sets `borderColor: "#ecfdf5"`. */
  get bcGreen50() {
    return this.add("borderColor", "#ecfdf5");
  }
  /** Sets `borderColor: "#d1fae5"`. */
  get bcGreen100() {
    return this.add("borderColor", "#d1fae5");
  }
  /** Sets `borderColor: "#a7f3d0"`. */
  get bcGreen200() {
    return this.add("borderColor", "#a7f3d0");
  }
  /** Sets `borderColor: "#6ee7b7"`. */
  get bcGreen300() {
    return this.add("borderColor", "#6ee7b7");
  }
  /** Sets `borderColor: "#34d399"`. */
  get bcGreen400() {
    return this.add("borderColor", "#34d399");
  }
  /** Sets `borderColor: "#10b981"`. */
  get bcGreen500() {
    return this.add("borderColor", "#10b981");
  }
  /** Sets `borderColor: "#059669"`. */
  get bcGreen600() {
    return this.add("borderColor", "#059669");
  }
  /** Sets `borderColor: "#047857"`. */
  get bcGreen700() {
    return this.add("borderColor", "#047857");
  }
  /** Sets `borderColor: "#065f46"`. */
  get bcGreen800() {
    return this.add("borderColor", "#065f46");
  }
  /** Sets `borderColor: "#064e3b"`. */
  get bcGreen900() {
    return this.add("borderColor", "#064e3b");
  }
  /** Sets `borderColor: "#f5f3ff"`. */
  get bcPurple50() {
    return this.add("borderColor", "#f5f3ff");
  }
  /** Sets `borderColor: "#ede9fe"`. */
  get bcPurple100() {
    return this.add("borderColor", "#ede9fe");
  }
  /** Sets `borderColor: "#ddd6fe"`. */
  get bcPurple200() {
    return this.add("borderColor", "#ddd6fe");
  }
  /** Sets `borderColor: "#c4b5fd"`. */
  get bcPurple300() {
    return this.add("borderColor", "#c4b5fd");
  }
  /** Sets `borderColor: "#a78bfa"`. */
  get bcPurple400() {
    return this.add("borderColor", "#a78bfa");
  }
  /** Sets `borderColor: "#8b5cf6"`. */
  get bcPurple500() {
    return this.add("borderColor", "#8b5cf6");
  }
  /** Sets `borderColor: "#7c3aed"`. */
  get bcPurple600() {
    return this.add("borderColor", "#7c3aed");
  }
  /** Sets `borderColor: "#6d28d9"`. */
  get bcPurple700() {
    return this.add("borderColor", "#6d28d9");
  }
  /** Sets `borderColor: "#5b21b6"`. */
  get bcPurple800() {
    return this.add("borderColor", "#5b21b6");
  }
  /** Sets `borderColor: "#4c1d95"`. */
  get bcPurple900() {
    return this.add("borderColor", "#4c1d95");
  }
  /** Sets `borderColor: "#DA1E28"`. */
  get bcRedError() {
    return this.add("borderColor", "#DA1E28");
  }
  /** Sets `borderColor: "#fef2f2"`. */
  get bcRed50() {
    return this.add("borderColor", "#fef2f2");
  }
  /** Sets `borderColor: "#fee2e2"`. */
  get bcRed100() {
    return this.add("borderColor", "#fee2e2");
  }
  /** Sets `borderColor: "#fecaca"`. */
  get bcRed200() {
    return this.add("borderColor", "#fecaca");
  }
  /** Sets `borderColor: "#fca5a5"`. */
  get bcRed300() {
    return this.add("borderColor", "#fca5a5");
  }
  /** Sets `borderColor: "#f87171"`. */
  get bcRed400() {
    return this.add("borderColor", "#f87171");
  }
  /** Sets `borderColor: "#ef4444"`. */
  get bcRed500() {
    return this.add("borderColor", "#ef4444");
  }
  /** Sets `borderColor: "#c86251"`. */
  get bcRed600() {
    return this.add("borderColor", "#c86251");
  }
  /** Sets `borderColor: "#b91c1c"`. */
  get bcRed700() {
    return this.add("borderColor", "#b91c1c");
  }
  /** Sets `borderColor: "#991b1b"`. */
  get bcRed800() {
    return this.add("borderColor", "#991b1b");
  }
  /** Sets `borderColor: "#7f1d1d"`. */
  get bcRed900() {
    return this.add("borderColor", "#7f1d1d");
  }
  /** Sets `borderColor: "#fefce8"`. */
  get bcYellow50() {
    return this.add("borderColor", "#fefce8");
  }
  /** Sets `borderColor: "#fef9c3"`. */
  get bcYellow100() {
    return this.add("borderColor", "#fef9c3");
  }
  /** Sets `borderColor: "#fef08a"`. */
  get bcYellow200() {
    return this.add("borderColor", "#fef08a");
  }
  /** Sets `borderColor: "#fde047"`. */
  get bcYellow300() {
    return this.add("borderColor", "#fde047");
  }
  /** Sets `borderColor: "#facc15"`. */
  get bcYellow400() {
    return this.add("borderColor", "#facc15");
  }
  /** Sets `borderColor: "#eab308"`. */
  get bcYellow500() {
    return this.add("borderColor", "#eab308");
  }
  /** Sets `borderColor: "#ca8a04"`. */
  get bcYellow600() {
    return this.add("borderColor", "#ca8a04");
  }
  /** Sets `borderColor: "#a16207"`. */
  get bcYellow700() {
    return this.add("borderColor", "#a16207");
  }
  /** Sets `borderColor: "#854d0e"`. */
  get bcYellow800() {
    return this.add("borderColor", "#854d0e");
  }
  /** Sets `borderColor: "#713f12"`. */
  get bcYellow900() {
    return this.add("borderColor", "#713f12");
  }
  /** Sets `borderColor: "#eff6ff"`. */
  get bcBlue50() {
    return this.add("borderColor", "#eff6ff");
  }
  /** Sets `borderColor: "#dbeafe"`. */
  get bcBlue100() {
    return this.add("borderColor", "#dbeafe");
  }
  /** Sets `borderColor: "#bfdbfe"`. */
  get bcBlue200() {
    return this.add("borderColor", "#bfdbfe");
  }
  /** Sets `borderColor: "#93c5fd"`. */
  get bcBlue300() {
    return this.add("borderColor", "#93c5fd");
  }
  /** Sets `borderColor: "#60a5fa"`. */
  get bcBlue400() {
    return this.add("borderColor", "#60a5fa");
  }
  /** Sets `borderColor: "#3b82f6"`. */
  get bcBlue500() {
    return this.add("borderColor", "#3b82f6");
  }
  /** Sets `borderColor: "#2563eb"`. */
  get bcBlue600() {
    return this.add("borderColor", "#2563eb");
  }
  /** Sets `borderColor: "#1d4ed8"`. */
  get bcBlue700() {
    return this.add("borderColor", "#1d4ed8");
  }
  /** Sets `borderColor: "#1e40af"`. */
  get bcBlue800() {
    return this.add("borderColor", "#1e40af");
  }
  /** Sets `borderColor: "#1e3a8a"`. */
  get bcBlue900() {
    return this.add("borderColor", "#1e3a8a");
  }
  /** Sets `borderColor: "#fff7ed"`. */
  get bcOrange50() {
    return this.add("borderColor", "#fff7ed");
  }
  /** Sets `borderColor: "#ffedd5"`. */
  get bcOrange100() {
    return this.add("borderColor", "#ffedd5");
  }
  /** Sets `borderColor: "#fed7aa"`. */
  get bcOrange200() {
    return this.add("borderColor", "#fed7aa");
  }
  /** Sets `borderColor: "#fdba74"`. */
  get bcOrange300() {
    return this.add("borderColor", "#fdba74");
  }
  /** Sets `borderColor: "#fb923c"`. */
  get bcOrange400() {
    return this.add("borderColor", "#fb923c");
  }
  /** Sets `borderColor: "#f97316"`. */
  get bcOrange500() {
    return this.add("borderColor", "#f97316");
  }
  /** Sets `borderColor: "#ea580c"`. */
  get bcOrange600() {
    return this.add("borderColor", "#ea580c");
  }
  /** Sets `borderColor: "#c2410c"`. */
  get bcOrange700() {
    return this.add("borderColor", "#c2410c");
  }
  /** Sets `borderColor: "#9a3412"`. */
  get bcOrange800() {
    return this.add("borderColor", "#9a3412");
  }
  /** Sets `borderColor: "#7c2d12"`. */
  get bcOrange900() {
    return this.add("borderColor", "#7c2d12");
  }
  /** Sets `borderColor: value`. */
  bc(value: Properties["borderColor"]) {
    return this.add("borderColor", value);
  }

  // borderRadius
  /** Sets `borderRadius: "0"`. */
  get br0() {
    return this.add("borderRadius", "0");
  }
  /** Sets `borderRadius: "4px"`. */
  get br4() {
    return this.add("borderRadius", "4px");
  }
  /** Sets `borderRadius: "8px"`. */
  get br8() {
    return this.add("borderRadius", "8px");
  }
  /** Sets `borderRadius: "12px"`. */
  get br12() {
    return this.add("borderRadius", "12px");
  }
  /** Sets `borderRadius: "16px"`. */
  get br16() {
    return this.add("borderRadius", "16px");
  }
  /** Sets `borderRadius: "24px"`. */
  get br24() {
    return this.add("borderRadius", "24px");
  }
  /** Sets `borderRadius: "100%"`. */
  get br100() {
    return this.add("borderRadius", "100%");
  }
  /** Sets `borderRadius: value`. */
  borderRadius(value: Properties["borderRadius"]) {
    return this.add("borderRadius", value);
  }

  // borderStyle
  /** Sets `borderStyle: "dashed"`. */
  get bsDashed() {
    return this.add("borderStyle", "dashed");
  }
  /** Sets `borderStyle: "dotted"`. */
  get bsDotted() {
    return this.add("borderStyle", "dotted");
  }
  /** Sets `borderStyle: "none"`. */
  get bsn() {
    return this.add("borderStyle", "none");
  }
  /** Sets `borderStyle: "solid"`. */
  get bss() {
    return this.add("borderStyle", "solid");
  }
  /** Sets `borderStyle: value`. */
  bs(value: Properties["borderStyle"]) {
    return this.add("borderStyle", value);
  }

  // borderWidth
  /** Sets `borderWidth: "1px"`. */
  get bw1() {
    return this.add("borderWidth", "1px");
  }
  /** Sets `borderWidth: "2px"`. */
  get bw2() {
    return this.add("borderWidth", "2px");
  }
  /** Sets `borderWidth: value`. */
  bw(value: Properties["borderWidth"]) {
    return this.add("borderWidth", value);
  }

  // boxShadow
  /** Sets `boxShadow: "none"`. */
  get bshNone() {
    return this.add("boxShadow", "none");
  }
  /** Sets `boxShadow: "0px 4px 12px 0px #D4D4D4CC"`. */
  get bsh() {
    return this.add("boxShadow", "0px 4px 12px 0px #D4D4D4CC");
  }
  /** Sets `boxShadow: "0px 2px 16px 0px rgba(17,24,39,0.03), 0px 4px 8px 0px rgba(17,24,39,0.08)"`. */
  get bshBasic() {
    return this.add("boxShadow", "0px 2px 16px 0px rgba(17,24,39,0.03), 0px 4px 8px 0px rgba(17,24,39,0.08)");
  }
  /** Sets `boxShadow: "0px 2px 24px 0px rgba(17,24,39,0.08), 0px 4px 8px 0px rgba(17,24,39,0.1)"`. */
  get bshHover() {
    return this.add("boxShadow", "0px 2px 24px 0px rgba(17,24,39,0.08), 0px 4px 8px 0px rgba(17,24,39,0.1)");
  }
  /** Sets `boxShadow: "0px 20px 25px -5px rgba(0,0,0,0.1), 0px 10px 10px -5px rgba(0,0,0,0.04)"`. */
  get bshModal() {
    return this.add("boxShadow", "0px 20px 25px -5px rgba(0,0,0,0.1), 0px 10px 10px -5px rgba(0,0,0,0.04)");
  }
  /** Sets `boxShadow: "0px 4px 8px 0px rgba(53, 53, 53, 0.08), 0px 2px 16px 0px rgba(53, 53, 53, 0.03)"`. */
  get bshButton() {
    return this.add("boxShadow", "0px 4px 8px 0px rgba(53, 53, 53, 0.08), 0px 2px 16px 0px rgba(53, 53, 53, 0.03)");
  }
  /** Sets `boxShadow: "0px 4px 4px 0px rgba(221, 221, 215, 0.5)"`. */
  get dropShadow() {
    return this.add("boxShadow", "0px 4px 4px 0px rgba(221, 221, 215, 0.5)");
  }
  /** Sets `boxShadow: value`. */
  boxShadow(value: Properties["boxShadow"]) {
    return this.add("boxShadow", value);
  }

  // container
  /** Sets `containerType: "size"`. */
  get cts() {
    return this.add("containerType", "size");
  }
  /** Sets `containerType: "inline-size"`. */
  get ctis() {
    return this.add("containerType", "inline-size");
  }
  /** Sets `containerType: "normal"`. */
  get ctn() {
    return this.add("containerType", "normal");
  }
  /** Sets `containerType: value`. */
  ct(value: Properties["containerType"]) {
    return this.add("containerType", value);
  }
  /** Sets `containerName: value`. */
  cn(value: Properties["containerName"]) {
    return this.add("containerName", value);
  }

  // coordinates
  /** Sets `top: "0px"`. */
  get top0() {
    return this.add("top", "0px");
  }
  /** Sets `top: "8px"`. */
  get top1() {
    return this.add("top", "8px");
  }
  /** Sets `top: "16px"`. */
  get top2() {
    return this.add("top", "16px");
  }
  /** Sets `top: "24px"`. */
  get top3() {
    return this.add("top", "24px");
  }
  /** Sets `top: "32px"`. */
  get top4() {
    return this.add("top", "32px");
  }
  /** Sets `top: "40px"`. */
  get top5() {
    return this.add("top", "40px");
  }
  /** Sets `top: "48px"`. */
  get top6() {
    return this.add("top", "48px");
  }
  /** Sets `top: "56px"`. */
  get top7() {
    return this.add("top", "56px");
  }
  /** Sets `top: "64px"`. */
  get top8() {
    return this.add("top", "64px");
  }
  /** Sets `top: "v"`. */
  top(v: number | string) {
    return this.add("top", maybeInc(v));
  }
  /** Sets `top: px`. */
  topPx(px: number) {
    return this.add("top", `${px}px`);
  }
  /** Sets `right: "0px"`. */
  get right0() {
    return this.add("right", "0px");
  }
  /** Sets `right: "8px"`. */
  get right1() {
    return this.add("right", "8px");
  }
  /** Sets `right: "16px"`. */
  get right2() {
    return this.add("right", "16px");
  }
  /** Sets `right: "24px"`. */
  get right3() {
    return this.add("right", "24px");
  }
  /** Sets `right: "32px"`. */
  get right4() {
    return this.add("right", "32px");
  }
  /** Sets `right: "40px"`. */
  get right5() {
    return this.add("right", "40px");
  }
  /** Sets `right: "48px"`. */
  get right6() {
    return this.add("right", "48px");
  }
  /** Sets `right: "56px"`. */
  get right7() {
    return this.add("right", "56px");
  }
  /** Sets `right: "64px"`. */
  get right8() {
    return this.add("right", "64px");
  }
  /** Sets `right: "v"`. */
  right(v: number | string) {
    return this.add("right", maybeInc(v));
  }
  /** Sets `right: px`. */
  rightPx(px: number) {
    return this.add("right", `${px}px`);
  }
  /** Sets `bottom: "0px"`. */
  get bottom0() {
    return this.add("bottom", "0px");
  }
  /** Sets `bottom: "8px"`. */
  get bottom1() {
    return this.add("bottom", "8px");
  }
  /** Sets `bottom: "16px"`. */
  get bottom2() {
    return this.add("bottom", "16px");
  }
  /** Sets `bottom: "24px"`. */
  get bottom3() {
    return this.add("bottom", "24px");
  }
  /** Sets `bottom: "32px"`. */
  get bottom4() {
    return this.add("bottom", "32px");
  }
  /** Sets `bottom: "40px"`. */
  get bottom5() {
    return this.add("bottom", "40px");
  }
  /** Sets `bottom: "48px"`. */
  get bottom6() {
    return this.add("bottom", "48px");
  }
  /** Sets `bottom: "56px"`. */
  get bottom7() {
    return this.add("bottom", "56px");
  }
  /** Sets `bottom: "64px"`. */
  get bottom8() {
    return this.add("bottom", "64px");
  }
  /** Sets `bottom: "v"`. */
  bottom(v: number | string) {
    return this.add("bottom", maybeInc(v));
  }
  /** Sets `bottom: px`. */
  bottomPx(px: number) {
    return this.add("bottom", `${px}px`);
  }
  /** Sets `left: "0px"`. */
  get left0() {
    return this.add("left", "0px");
  }
  /** Sets `left: "8px"`. */
  get left1() {
    return this.add("left", "8px");
  }
  /** Sets `left: "16px"`. */
  get left2() {
    return this.add("left", "16px");
  }
  /** Sets `left: "24px"`. */
  get left3() {
    return this.add("left", "24px");
  }
  /** Sets `left: "32px"`. */
  get left4() {
    return this.add("left", "32px");
  }
  /** Sets `left: "40px"`. */
  get left5() {
    return this.add("left", "40px");
  }
  /** Sets `left: "48px"`. */
  get left6() {
    return this.add("left", "48px");
  }
  /** Sets `left: "56px"`. */
  get left7() {
    return this.add("left", "56px");
  }
  /** Sets `left: "64px"`. */
  get left8() {
    return this.add("left", "64px");
  }
  /** Sets `left: "v"`. */
  left(v: number | string) {
    return this.add("left", maybeInc(v));
  }
  /** Sets `left: px`. */
  leftPx(px: number) {
    return this.add("left", `${px}px`);
  }

  // cursor
  /** Sets `cursor: "pointer"`. */
  get cursorPointer() {
    return this.add("cursor", "pointer");
  }
  /** Sets `cursor: "not-allowed"`. */
  get cursorNotAllowed() {
    return this.add("cursor", "not-allowed");
  }
  /** Sets `cursor: value`. */
  cursor(value: Properties["cursor"]) {
    return this.add("cursor", value);
  }

  // display
  /** Sets `display: "none"`. */
  get dn() {
    return this.add("display", "none");
  }
  /** Sets `display: "block"`. */
  get db() {
    return this.add("display", "block");
  }
  /** Sets `display: "inline-block"`. */
  get dib() {
    return this.add("display", "inline-block");
  }
  /** Sets `display: "inline-table"`. */
  get dit() {
    return this.add("display", "inline-table");
  }
  /** Sets `display: "table"`. */
  get dt() {
    return this.add("display", "table");
  }
  /** Sets `display: "table-cell"`. */
  get dtc() {
    return this.add("display", "table-cell");
  }
  /** Sets `display: "table-row"`. */
  get dtRow() {
    return this.add("display", "table-row");
  }
  /** Sets `display: "table-column"`. */
  get dtColumn() {
    return this.add("display", "table-column");
  }
  /** Sets `display: "table-column-group"`. */
  get dtColumnGroup() {
    return this.add("display", "table-column-group");
  }
  /** Sets `display: "grid"`. */
  get dg() {
    return this.add("display", "grid");
  }
  /** Sets `display: "inline-grid"`. */
  get dig() {
    return this.add("display", "inline-grid");
  }
  /** Sets `display: "flex"`. */
  get df() {
    return this.add("display", "flex");
  }
  /** Sets `display: "inline-flex"`. */
  get dif() {
    return this.add("display", "inline-flex");
  }
  /** Sets `display: value`. */
  display(value: Properties["display"]) {
    return this.add("display", value);
  }

  // flexbox
  /** Sets `flex: "initial"`. */
  get fi() {
    return this.add("flex", "initial");
  }
  /** Sets `flex: "auto"`. */
  get fa() {
    return this.add("flex", "auto");
  }
  /** Sets `flex: "none"`. */
  get fn() {
    return this.add("flex", "none");
  }
  /** Sets `flex: "1"`. */
  get f1() {
    return this.add("flex", "1");
  }
  /** Sets `flex: "2"`. */
  get f2() {
    return this.add("flex", "2");
  }
  /** Sets `flex: "3"`. */
  get f3() {
    return this.add("flex", "3");
  }
  /** Sets `flex: "4"`. */
  get f4() {
    return this.add("flex", "4");
  }
  /** Sets `flex: "5"`. */
  get f5() {
    return this.add("flex", "5");
  }
  /** Sets `flex: value`. */
  f(value: Properties["flex"]) {
    return this.add("flex", value);
  }
  /** Sets `justifyContent: "flex-start"`. */
  get jcfs() {
    return this.add("justifyContent", "flex-start");
  }
  /** Sets `justifyContent: "flex-end"`. */
  get jcfe() {
    return this.add("justifyContent", "flex-end");
  }
  /** Sets `justifyContent: "center"`. */
  get jcc() {
    return this.add("justifyContent", "center");
  }
  /** Sets `justifyContent: "space-between"`. */
  get jcsb() {
    return this.add("justifyContent", "space-between");
  }
  /** Sets `justifyContent: "space-around"`. */
  get jcsa() {
    return this.add("justifyContent", "space-around");
  }
  /** Sets `justifyContent: "space-evenly"`. */
  get jcse() {
    return this.add("justifyContent", "space-evenly");
  }
  /** Sets `justifyContent: value`. */
  jc(value: Properties["justifyContent"]) {
    return this.add("justifyContent", value);
  }
  /** Sets `justifySelf: "auto"`. */
  get jsa() {
    return this.add("justifySelf", "auto");
  }
  /** Sets `justifySelf: "center"`. */
  get jsc() {
    return this.add("justifySelf", "center");
  }
  /** Sets `justifySelf: "start"`. */
  get jss() {
    return this.add("justifySelf", "start");
  }
  /** Sets `justifySelf: "end"`. */
  get jse() {
    return this.add("justifySelf", "end");
  }
  /** Sets `justifySelf: value`. */
  js(value: Properties["justifySelf"]) {
    return this.add("justifySelf", value);
  }
  /** Sets `justifyItems: "flex-start"`. */
  get jifs() {
    return this.add("justifyItems", "flex-start");
  }
  /** Sets `justifyItems: "flex-end"`. */
  get jife() {
    return this.add("justifyItems", "flex-end");
  }
  /** Sets `justifyItems: "center"`. */
  get jic() {
    return this.add("justifyItems", "center");
  }
  /** Sets `justifyItems: "space-between"`. */
  get jisb() {
    return this.add("justifyItems", "space-between");
  }
  /** Sets `justifyItems: "space-around"`. */
  get jisa() {
    return this.add("justifyItems", "space-around");
  }
  /** Sets `justifyItems: "space-evenly"`. */
  get jise() {
    return this.add("justifyItems", "space-evenly");
  }
  /** Sets `justifyItems: value`. */
  ji(value: Properties["justifyItems"]) {
    return this.add("justifyItems", value);
  }
  /** Sets `alignSelf: "flex-start"`. */
  get asfs() {
    return this.add("alignSelf", "flex-start");
  }
  /** Sets `alignSelf: "flex-end"`. */
  get asfe() {
    return this.add("alignSelf", "flex-end");
  }
  /** Sets `alignSelf: "center"`. */
  get asc() {
    return this.add("alignSelf", "center");
  }
  /** Sets `alignSelf: "baseline"`. */
  get asb() {
    return this.add("alignSelf", "baseline");
  }
  /** Sets `alignSelf: "stretch"`. */
  get asStretch() {
    return this.add("alignSelf", "stretch");
  }
  /** Sets `alignSelf: value`. */
  as(value: Properties["alignSelf"]) {
    return this.add("alignSelf", value);
  }
  /** Sets `alignItems: "flex-start"`. */
  get aifs() {
    return this.add("alignItems", "flex-start");
  }
  /** Sets `alignItems: "flex-end"`. */
  get aife() {
    return this.add("alignItems", "flex-end");
  }
  /** Sets `alignItems: "start"`. */
  get ais() {
    return this.add("alignItems", "start");
  }
  /** Sets `alignItems: "end"`. */
  get aie() {
    return this.add("alignItems", "end");
  }
  /** Sets `alignItems: "center"`. */
  get aic() {
    return this.add("alignItems", "center");
  }
  /** Sets `alignItems: "baseline"`. */
  get aib() {
    return this.add("alignItems", "baseline");
  }
  /** Sets `alignItems: "stretch"`. */
  get aiStretch() {
    return this.add("alignItems", "stretch");
  }
  /** Sets `alignItems: value`. */
  ai(value: Properties["alignItems"]) {
    return this.add("alignItems", value);
  }
  /** Sets `placeSelf: "auto"`. */
  get psa() {
    return this.add("placeSelf", "auto");
  }
  /** Sets `placeSelf: "center"`. */
  get psc() {
    return this.add("placeSelf", "center");
  }
  /** Sets `placeSelf: "start"`. */
  get pss() {
    return this.add("placeSelf", "start");
  }
  /** Sets `placeSelf: "end"`. */
  get pse() {
    return this.add("placeSelf", "end");
  }
  /** Sets `placeSelf: "flex-start"`. */
  get psfs() {
    return this.add("placeSelf", "flex-start");
  }
  /** Sets `placeSelf: "flex-end"`. */
  get psfe() {
    return this.add("placeSelf", "flex-end");
  }
  /** Sets `placeSelf: "stretch"`. */
  get psStretch() {
    return this.add("placeSelf", "stretch");
  }
  /** Sets `placeSelf: value`. */
  ps(value: Properties["placeSelf"]) {
    return this.add("placeSelf", value);
  }
  /** Sets `placeContent: "center"`. */
  get pcc() {
    return this.add("placeContent", "center");
  }
  /** Sets `placeContent: "start"`. */
  get pcs() {
    return this.add("placeContent", "start");
  }
  /** Sets `placeContent: "end"`. */
  get pce() {
    return this.add("placeContent", "end");
  }
  /** Sets `placeContent: "space-between"`. */
  get pcsb() {
    return this.add("placeContent", "space-between");
  }
  /** Sets `placeContent: "space-around"`. */
  get pcsa() {
    return this.add("placeContent", "space-around");
  }
  /** Sets `placeContent: "space-evenly"`. */
  get pcse() {
    return this.add("placeContent", "space-evenly");
  }
  /** Sets `placeContent: "baseline"`. */
  get pcb() {
    return this.add("placeContent", "baseline");
  }
  /** Sets `placeContent: "stretch"`. */
  get pcStretch() {
    return this.add("placeContent", "stretch");
  }
  /** Sets `placeContent: value`. */
  pc(value: Properties["placeContent"]) {
    return this.add("placeContent", value);
  }
  /** Sets `placeItems: "center"`. */
  get pic() {
    return this.add("placeItems", "center");
  }
  /** Sets `placeItems: "start"`. */
  get pis() {
    return this.add("placeItems", "start");
  }
  /** Sets `placeItems: "end"`. */
  get pie() {
    return this.add("placeItems", "end");
  }
  /** Sets `placeItems: "space-between"`. */
  get pisb() {
    return this.add("placeItems", "space-between");
  }
  /** Sets `placeItems: "space-around"`. */
  get pisa() {
    return this.add("placeItems", "space-around");
  }
  /** Sets `placeItems: "space-evenly"`. */
  get pise() {
    return this.add("placeItems", "space-evenly");
  }
  /** Sets `placeItems: "baseline"`. */
  get pib() {
    return this.add("placeItems", "baseline");
  }
  /** Sets `placeItems: "stretch"`. */
  get piStretch() {
    return this.add("placeItems", "stretch");
  }
  /** Sets `placeItems: value`. */
  pi(value: Properties["placeItems"]) {
    return this.add("placeItems", value);
  }
  /** Sets `flexBasis: "100%"`. */
  get fb1() {
    return this.add("flexBasis", "100%");
  }
  /** Sets `flexBasis: "50%"`. */
  get fb2() {
    return this.add("flexBasis", "50%");
  }
  /** Sets `flexBasis: "33.333333%"`. */
  get fb3() {
    return this.add("flexBasis", "33.333333%");
  }
  /** Sets `flexBasis: "25%"`. */
  get fb4() {
    return this.add("flexBasis", "25%");
  }
  /** Sets `flexBasis: "20%"`. */
  get fb5() {
    return this.add("flexBasis", "20%");
  }
  /** Sets `flexBasis: "16.666666%"`. */
  get fb6() {
    return this.add("flexBasis", "16.666666%");
  }
  /** Sets `flexBasis: "14.285714%"`. */
  get fb7() {
    return this.add("flexBasis", "14.285714%");
  }
  /** Sets `flexBasis: "12.5%"`. */
  get fb0() {
    return this.add("flexBasis", "12.5%");
  }
  /** Sets `flexBasis: value`. */
  fb(value: Properties["flexBasis"]) {
    return this.add("flexBasis", value);
  }
  /** Sets `flexGrow: 0`. */
  get fg0() {
    return this.add("flexGrow", 0);
  }
  /** Sets `flexGrow: 1`. */
  get fg1() {
    return this.add("flexGrow", 1);
  }
  /** Sets `flexGrow: value`. */
  flexGrow(value: Properties["flexGrow"]) {
    return this.add("flexGrow", value);
  }
  /** Sets `flexShrink: 0`. */
  get fs0() {
    return this.add("flexShrink", 0);
  }
  /** Sets `flexShrink: 1`. */
  get fs1() {
    return this.add("flexShrink", 1);
  }
  /** Sets `flexShrink: value`. */
  flexShrink(value: Properties["flexShrink"]) {
    return this.add("flexShrink", value);
  }
  /** Sets `flexDirection: "row"`. */
  get fdr() {
    return this.add("flexDirection", "row");
  }
  /** Sets `flexDirection: "row-reverse"`. */
  get fdrr() {
    return this.add("flexDirection", "row-reverse");
  }
  /** Sets `flexDirection: "column"`. */
  get fdc() {
    return this.add("flexDirection", "column");
  }
  /** Sets `flexDirection: "column-reverse"`. */
  get fdcr() {
    return this.add("flexDirection", "column-reverse");
  }
  /** Sets `flexDirection: value`. */
  fd(value: Properties["flexDirection"]) {
    return this.add("flexDirection", value);
  }
  /** Sets `flexWrap: "wrap"`. */
  get fww() {
    return this.add("flexWrap", "wrap");
  }
  /** Sets `flexWrap: "wrap-reverse"`. */
  get fwr() {
    return this.add("flexWrap", "wrap-reverse");
  }
  /** Sets `flexWrap: "nowrap"`. */
  get fwnw() {
    return this.add("flexWrap", "nowrap");
  }
  /** Sets `flexWrap: value`. */
  flexWrap(value: Properties["flexWrap"]) {
    return this.add("flexWrap", value);
  }
  /** Sets `order: value`. */
  order(value: Properties["order"]) {
    return this.add("order", value);
  }

  // float
  /** Sets `float: "left"`. */
  get fl() {
    return this.add("float", "left");
  }
  /** Sets `float: "right"`. */
  get fr() {
    return this.add("float", "right");
  }
  /** Sets `float: value`. */
  float(value: Properties["float"]) {
    return this.add("float", value);
  }

  // fontWeight
  /** Sets `fontWeight: 100`. */
  get fw100() {
    return this.add("fontWeight", 100);
  }
  /** Sets `fontWeight: 200`. */
  get fw200() {
    return this.add("fontWeight", 200);
  }
  /** Sets `fontWeight: 300`. */
  get fw300() {
    return this.add("fontWeight", 300);
  }
  /** Sets `fontWeight: 400`. */
  get fw400() {
    return this.add("fontWeight", 400);
  }
  /** Sets `fontWeight: 500`. */
  get fw500() {
    return this.add("fontWeight", 500);
  }
  /** Sets `fontWeight: 600`. */
  get fw600() {
    return this.add("fontWeight", 600);
  }
  /** Sets `fontWeight: 700`. */
  get fw700() {
    return this.add("fontWeight", 700);
  }
  /** Sets `fontWeight: 800`. */
  get fw800() {
    return this.add("fontWeight", 800);
  }
  /** Sets `fontWeight: 900`. */
  get fw900() {
    return this.add("fontWeight", 900);
  }
  /** Sets `fontWeight: 950`. */
  get fw950() {
    return this.add("fontWeight", 950);
  }

  // grid
  /** Sets `gridTemplateColumns: value`. */
  gtc(value: Properties["gridTemplateColumns"]) {
    return this.add("gridTemplateColumns", value);
  }
  /** Sets `gridTemplateRows: value`. */
  gtr(value: Properties["gridTemplateRows"]) {
    return this.add("gridTemplateRows", value);
  }
  /** Sets `gridRow: value`. */
  gr(value: Properties["gridRow"]) {
    return this.add("gridRow", value);
  }
  /** Sets `gridColumn: value`. */
  gc(value: Properties["gridColumn"]) {
    return this.add("gridColumn", value);
  }
  /** Sets `gridAutoRows: value`. */
  gar(value: Properties["gridAutoRows"]) {
    return this.add("gridAutoRows", value);
  }
  /** Sets `gridAutoColumns: value`. */
  gac(value: Properties["gridAutoColumns"]) {
    return this.add("gridAutoColumns", value);
  }
  /** Sets `gap: "0px"`. */
  get gap0() {
    return this.add("gap", "0px");
  }
  /** Sets `gap: "8px"`. */
  get gap1() {
    return this.add("gap", "8px");
  }
  /** Sets `gap: "16px"`. */
  get gap2() {
    return this.add("gap", "16px");
  }
  /** Sets `gap: "24px"`. */
  get gap3() {
    return this.add("gap", "24px");
  }
  /** Sets `gap: "32px"`. */
  get gap4() {
    return this.add("gap", "32px");
  }
  /** Sets `gap: "40px"`. */
  get gap5() {
    return this.add("gap", "40px");
  }
  /** Sets `gap: "48px"`. */
  get gap6() {
    return this.add("gap", "48px");
  }
  /** Sets `gap: "56px"`. */
  get gap7() {
    return this.add("gap", "56px");
  }
  /** Sets `gap: "64px"`. */
  get gap8() {
    return this.add("gap", "64px");
  }
  /** Sets `gap: "v"`. */
  gap(v: number | string) {
    return this.add("gap", maybeInc(v));
  }
  /** Sets `gap: px`. */
  gapPx(px: number) {
    return this.add("gap", `${px}px`);
  }
  /** Sets `rowGap: "0px"`. */
  get rg0() {
    return this.add("rowGap", "0px");
  }
  /** Sets `rowGap: "8px"`. */
  get rg1() {
    return this.add("rowGap", "8px");
  }
  /** Sets `rowGap: "16px"`. */
  get rg2() {
    return this.add("rowGap", "16px");
  }
  /** Sets `rowGap: "24px"`. */
  get rg3() {
    return this.add("rowGap", "24px");
  }
  /** Sets `rowGap: "32px"`. */
  get rg4() {
    return this.add("rowGap", "32px");
  }
  /** Sets `rowGap: "40px"`. */
  get rg5() {
    return this.add("rowGap", "40px");
  }
  /** Sets `rowGap: "48px"`. */
  get rg6() {
    return this.add("rowGap", "48px");
  }
  /** Sets `rowGap: "56px"`. */
  get rg7() {
    return this.add("rowGap", "56px");
  }
  /** Sets `rowGap: "64px"`. */
  get rg8() {
    return this.add("rowGap", "64px");
  }
  /** Sets `rowGap: "v"`. */
  rg(v: number | string) {
    return this.add("rowGap", maybeInc(v));
  }
  /** Sets `rowGap: px`. */
  rgPx(px: number) {
    return this.add("rowGap", `${px}px`);
  }
  /** Sets `columnGap: "0px"`. */
  get cg0() {
    return this.add("columnGap", "0px");
  }
  /** Sets `columnGap: "8px"`. */
  get cg1() {
    return this.add("columnGap", "8px");
  }
  /** Sets `columnGap: "16px"`. */
  get cg2() {
    return this.add("columnGap", "16px");
  }
  /** Sets `columnGap: "24px"`. */
  get cg3() {
    return this.add("columnGap", "24px");
  }
  /** Sets `columnGap: "32px"`. */
  get cg4() {
    return this.add("columnGap", "32px");
  }
  /** Sets `columnGap: "40px"`. */
  get cg5() {
    return this.add("columnGap", "40px");
  }
  /** Sets `columnGap: "48px"`. */
  get cg6() {
    return this.add("columnGap", "48px");
  }
  /** Sets `columnGap: "56px"`. */
  get cg7() {
    return this.add("columnGap", "56px");
  }
  /** Sets `columnGap: "64px"`. */
  get cg8() {
    return this.add("columnGap", "64px");
  }
  /** Sets `columnGap: "v"`. */
  cg(v: number | string) {
    return this.add("columnGap", maybeInc(v));
  }
  /** Sets `columnGap: px`. */
  cgPx(px: number) {
    return this.add("columnGap", `${px}px`);
  }

  // height
  /** Sets `height: "0px"`. */
  get h0() {
    return this.add("height", "0px");
  }
  /** Sets `height: "8px"`. */
  get h1() {
    return this.add("height", "8px");
  }
  /** Sets `height: "16px"`. */
  get h2() {
    return this.add("height", "16px");
  }
  /** Sets `height: "24px"`. */
  get h3() {
    return this.add("height", "24px");
  }
  /** Sets `height: "32px"`. */
  get h4() {
    return this.add("height", "32px");
  }
  /** Sets `height: "40px"`. */
  get h5() {
    return this.add("height", "40px");
  }
  /** Sets `height: "48px"`. */
  get h6() {
    return this.add("height", "48px");
  }
  /** Sets `height: "56px"`. */
  get h7() {
    return this.add("height", "56px");
  }
  /** Sets `height: "64px"`. */
  get h8() {
    return this.add("height", "64px");
  }
  /** Sets `height: "auto"`. */
  get ha() {
    return this.add("height", "auto");
  }
  /** Sets `height: "v"`. */
  h(v: number | string) {
    return this.add("height", maybeInc(v));
  }
  /** Sets `height: px`. */
  hPx(px: number) {
    return this.add("height", `${px}px`);
  }
  /** Sets `height: "25%"`. */
  get h25() {
    return this.add("height", "25%");
  }
  /** Sets `height: "50%"`. */
  get h50() {
    return this.add("height", "50%");
  }
  /** Sets `height: "75%"`. */
  get h75() {
    return this.add("height", "75%");
  }
  /** Sets `height: "100%"`. */
  get h100() {
    return this.add("height", "100%");
  }
  /** Sets `height: "25vh"`. */
  get vh25() {
    return this.add("height", "25vh");
  }
  /** Sets `height: "50vh"`. */
  get vh50() {
    return this.add("height", "50vh");
  }
  /** Sets `height: "75vh"`. */
  get vh75() {
    return this.add("height", "75vh");
  }
  /** Sets `height: "100vh"`. */
  get vh100() {
    return this.add("height", "100vh");
  }
  /** Sets `height: "fit-content"`. */
  get hfc() {
    return this.add("height", "fit-content");
  }
  /** Sets `height: "max-content"`. */
  get hmaxc() {
    return this.add("height", "max-content");
  }
  /** Sets `height: "min-content"`. */
  get hminc() {
    return this.add("height", "min-content");
  }
  /** Sets `minHeight: 0`. */
  get mh0() {
    return this.add("minHeight", 0);
  }
  /** Sets `minHeight: "25%"`. */
  get mh25() {
    return this.add("minHeight", "25%");
  }
  /** Sets `minHeight: "50%"`. */
  get mh50() {
    return this.add("minHeight", "50%");
  }
  /** Sets `minHeight: "75%"`. */
  get mh75() {
    return this.add("minHeight", "75%");
  }
  /** Sets `minHeight: "100%"`. */
  get mh100() {
    return this.add("minHeight", "100%");
  }
  /** Sets `minHeight: "100vh"`. */
  get mvh100() {
    return this.add("minHeight", "100vh");
  }
  /** Sets `minHeight: value`. */
  mh(value: Properties["minHeight"]) {
    return this.add("minHeight", value);
  }
  /** Sets `minHeight: px`. */
  mhPx(px: number) {
    return this.mh(`${px}px`);
  }
  /** Sets `maxHeight: "0"`. */
  get maxh0() {
    return this.add("maxHeight", "0");
  }
  /** Sets `maxHeight: "25%"`. */
  get maxh25() {
    return this.add("maxHeight", "25%");
  }
  /** Sets `maxHeight: "50%"`. */
  get maxh50() {
    return this.add("maxHeight", "50%");
  }
  /** Sets `maxHeight: "75%"`. */
  get maxh75() {
    return this.add("maxHeight", "75%");
  }
  /** Sets `maxHeight: "100%"`. */
  get maxh100() {
    return this.add("maxHeight", "100%");
  }
  /** Sets `maxHeight: value`. */
  maxh(value: Properties["maxHeight"]) {
    return this.add("maxHeight", value);
  }
  /** Sets `maxHeight: px`. */
  maxhPx(px: number) {
    return this.maxh(`${px}px`);
  }
  /** Sets `height: px; width: px`. */

  sqPx(px: number) {
    return this.add("height", `${px}px`).add("width", `${px}px`);
  }

  // lineClamp
  /** Sets `overflow: "hidden"; display: "-webkit-box"; WebkitBoxOrient: "vertical"; textOverflow: "ellipsis"; WebkitLineClamp: 1`. */
  get lineClamp1() {
    return this.add("overflow", "hidden").add("display", "-webkit-box").add("WebkitBoxOrient", "vertical").add(
      "textOverflow",
      "ellipsis",
    ).add("WebkitLineClamp", 1);
  }
  /** Sets `overflow: "hidden"; display: "-webkit-box"; WebkitBoxOrient: "vertical"; textOverflow: "ellipsis"; WebkitLineClamp: 2`. */
  get lineClamp2() {
    return this.add("overflow", "hidden").add("display", "-webkit-box").add("WebkitBoxOrient", "vertical").add(
      "textOverflow",
      "ellipsis",
    ).add("WebkitLineClamp", 2);
  }
  /** Sets `overflow: "hidden"; display: "-webkit-box"; WebkitBoxOrient: "vertical"; textOverflow: "ellipsis"; WebkitLineClamp: 3`. */
  get lineClamp3() {
    return this.add("overflow", "hidden").add("display", "-webkit-box").add("WebkitBoxOrient", "vertical").add(
      "textOverflow",
      "ellipsis",
    ).add("WebkitLineClamp", 3);
  }
  /** Sets `overflow: "hidden"; display: "-webkit-box"; WebkitBoxOrient: "vertical"; textOverflow: "ellipsis"; WebkitLineClamp: 4`. */
  get lineClamp4() {
    return this.add("overflow", "hidden").add("display", "-webkit-box").add("WebkitBoxOrient", "vertical").add(
      "textOverflow",
      "ellipsis",
    ).add("WebkitLineClamp", 4);
  }
  /** Sets `overflow: "hidden"; display: "-webkit-box"; WebkitBoxOrient: "vertical"; textOverflow: "ellipsis"; WebkitLineClamp: 5`. */
  get lineClamp5() {
    return this.add("overflow", "hidden").add("display", "-webkit-box").add("WebkitBoxOrient", "vertical").add(
      "textOverflow",
      "ellipsis",
    ).add("WebkitLineClamp", 5);
  }
  /** Sets `overflow: "hidden"; display: "-webkit-box"; WebkitBoxOrient: "vertical"; textOverflow: "ellipsis"; WebkitLineClamp: 6`. */
  get lineClamp6() {
    return this.add("overflow", "hidden").add("display", "-webkit-box").add("WebkitBoxOrient", "vertical").add(
      "textOverflow",
      "ellipsis",
    ).add("WebkitLineClamp", 6);
  }
  /** Sets `WebkitLineClamp: "unset"`. */
  get lineClampNone() {
    return this.add("WebkitLineClamp", "unset");
  }
  /** Sets `WebkitLineClamp: value`. */
  lineClamp(value: Properties["WebkitLineClamp"]) {
    return this.add("WebkitLineClamp", value).add("overflow", "hidden").add("display", "-webkit-box").add(
      "WebkitBoxOrient",
      "vertical",
    ).add("textOverflow", "ellipsis");
  }

  // objectFit
  /** Sets `objectFit: "contain"`. */
  get objectContain() {
    return this.add("objectFit", "contain");
  }
  /** Sets `objectFit: "cover"`. */
  get objectCover() {
    return this.add("objectFit", "cover");
  }
  /** Sets `objectFit: "fill"`. */
  get objectFill() {
    return this.add("objectFit", "fill");
  }
  /** Sets `objectFit: "none"`. */
  get objectNone() {
    return this.add("objectFit", "none");
  }
  /** Sets `objectFit: "scale-down"`. */
  get objectScaleDown() {
    return this.add("objectFit", "scale-down");
  }
  /** Sets `objectFit: value`. */
  objectFit(value: Properties["objectFit"]) {
    return this.add("objectFit", value);
  }

  // opacity
  /** Sets `opacity: "0"`. */
  get o0() {
    return this.add("opacity", "0");
  }
  /** Sets `opacity: "0.25"`. */
  get o25() {
    return this.add("opacity", "0.25");
  }
  /** Sets `opacity: "0.5"`. */
  get o50() {
    return this.add("opacity", "0.5");
  }
  /** Sets `opacity: "0.75"`. */
  get o75() {
    return this.add("opacity", "0.75");
  }
  /** Sets `opacity: "1"`. */
  get o100() {
    return this.add("opacity", "1");
  }
  /** Sets `opacity: value`. */
  o(value: Properties["opacity"]) {
    return this.add("opacity", value);
  }

  // outline
  /** Sets `outline: "1px solid"`. */
  get outline1() {
    return this.add("outline", "1px solid");
  }
  /** Sets `outline: "1px solid transparent"`. */
  get outlineTransparent() {
    return this.add("outline", "1px solid transparent");
  }
  /** Sets `outline: "0"`. */
  get outline0() {
    return this.add("outline", "0");
  }
  /** Sets `outline: value`. */
  outline(value: Properties["outline"]) {
    return this.add("outline", value);
  }

  // overflow
  /** Sets `overflow: "visible"`. */
  get ov() {
    return this.add("overflow", "visible");
  }
  /** Sets `overflow: "hidden"`. */
  get oh() {
    return this.add("overflow", "hidden");
  }
  /** Sets `overflow: "scroll"`. */
  get os() {
    return this.add("overflow", "scroll");
  }
  /** Sets `overflow: "auto"`. */
  get oa() {
    return this.add("overflow", "auto");
  }
  /** Sets `overflow: value`. */
  overflow(value: Properties["overflow"]) {
    return this.add("overflow", value);
  }
  /** Sets `overflowY: "visible"`. */
  get oyv() {
    return this.add("overflowY", "visible");
  }
  /** Sets `overflowY: "hidden"`. */
  get oyh() {
    return this.add("overflowY", "hidden");
  }
  /** Sets `overflowY: "scroll"`. */
  get oys() {
    return this.add("overflowY", "scroll");
  }
  /** Sets `overflowY: "auto"`. */
  get oya() {
    return this.add("overflowY", "auto");
  }
  /** Sets `overflowY: value`. */
  overflowY(value: Properties["overflowY"]) {
    return this.add("overflowY", value);
  }
  /** Sets `overflowX: "visible"`. */
  get oxv() {
    return this.add("overflowX", "visible");
  }
  /** Sets `overflowX: "hidden"`. */
  get oxh() {
    return this.add("overflowX", "hidden");
  }
  /** Sets `overflowX: "scroll"`. */
  get oxs() {
    return this.add("overflowX", "scroll");
  }
  /** Sets `overflowX: "auto"`. */
  get oxa() {
    return this.add("overflowX", "auto");
  }
  /** Sets `overflowX: value`. */
  overflowX(value: Properties["overflowX"]) {
    return this.add("overflowX", value);
  }

  // position
  /** Sets `position: "absolute"`. */
  get absolute() {
    return this.add("position", "absolute");
  }
  /** Sets `position: "fixed"`. */
  get fixed() {
    return this.add("position", "fixed");
  }
  /** Sets `position: "static"`. */
  get static() {
    return this.add("position", "static");
  }
  /** Sets `position: "relative"`. */
  get relative() {
    return this.add("position", "relative");
  }
  /** Sets `position: "sticky"`. */
  get sticky() {
    return this.add("position", "sticky");
  }
  /** Sets `position: value`. */
  position(value: Properties["position"]) {
    return this.add("position", value);
  }

  // skins
  /** Sets `color: "#FFFFFF"`. */
  get white() {
    return this.add("color", "#FFFFFF");
  }
  /** Sets `color: "#F6F6F0"`. */
  get offWhite() {
    return this.add("color", "#F6F6F0");
  }
  /** Sets `color: "#000000"`. */
  get black() {
    return this.add("color", "#000000");
  }
  /** Sets `color: "#0067C5"`. */
  get bpBlue() {
    return this.add("color", "#0067C5");
  }
  /** Sets `color: "#EBEAE4FF"`. */
  get taupe() {
    return this.add("color", "#EBEAE4FF");
  }
  /** Sets `color: "#888888"`. */
  get gray() {
    return this.add("color", "#888888");
  }
  /** Sets `color: "#00000000"`. */
  get transparent() {
    return this.add("color", "#00000000");
  }
  /** Sets `color: "#000000B2"`. */
  get translucentBlack() {
    return this.add("color", "#000000B2");
  }
  /** Sets `color: "#F6B14E"`. */
  get brightYellow() {
    return this.add("color", "#F6B14E");
  }
  /** Sets `color: "#AEB564"`. */
  get brightGreen() {
    return this.add("color", "#AEB564");
  }
  /** Sets `color: "#3A759D"`. */
  get brightBlue() {
    return this.add("color", "#3A759D");
  }
  /** Sets `color: "#C86251"`. */
  get brightStrawberry() {
    return this.add("color", "#C86251");
  }
  /** Sets `color: "#8B514E"`. */
  get saturatedWine() {
    return this.add("color", "#8B514E");
  }
  /** Sets `color: "#D17520"`. */
  get saturatedOrange() {
    return this.add("color", "#D17520");
  }
  /** Sets `color: "#657839"`. */
  get saturatedGrass() {
    return this.add("color", "#657839");
  }
  /** Sets `color: "#9CA084"`. */
  get moss() {
    return this.add("color", "#9CA084");
  }
  /** Sets `color: "#5F477F"`. */
  get plum() {
    return this.add("color", "#5F477F");
  }
  /** Sets `color: "#CECECE"`. */
  get lightGray() {
    return this.add("color", "#CECECE");
  }
  /** Sets `color: "#66666DFF"`. */
  get midGray() {
    return this.add("color", "#66666DFF");
  }
  /** Sets `color: "#D2D7DD"`. */
  get lightBlue() {
    return this.add("color", "#D2D7DD");
  }
  /** Sets `color: "#F7E9D5"`. */
  get lightPeach() {
    return this.add("color", "#F7E9D5");
  }
  /** Sets `color: "#353535CC"`. */
  get gray80() {
    return this.add("color", "#353535CC");
  }
  /** Sets `color: "#3535350A"`. */
  get gray4() {
    return this.add("color", "#3535350A");
  }
  /** Sets `color: "#35353514"`. */
  get gray8() {
    return this.add("color", "#35353514");
  }
  /** Sets `color: "#35353529"`. */
  get gray16() {
    return this.add("color", "#35353529");
  }
  /** Sets `color: "#fffdfd"`. */
  get gray50() {
    return this.add("color", "#fffdfd");
  }
  /** Sets `color: "#F7F5F5"`. */
  get gray100() {
    return this.add("color", "#F7F5F5");
  }
  /** Sets `color: "#ECEBEB"`. */
  get gray200() {
    return this.add("color", "#ECEBEB");
  }
  /** Sets `color: "#DDDCDC"`. */
  get gray300() {
    return this.add("color", "#DDDCDC");
  }
  /** Sets `color: "#C9C9C9"`. */
  get gray400() {
    return this.add("color", "#C9C9C9");
  }
  /** Sets `color: "#AFAFAF"`. */
  get gray500() {
    return this.add("color", "#AFAFAF");
  }
  /** Sets `color: "#8D8D8D"`. */
  get gray600() {
    return this.add("color", "#8D8D8D");
  }
  /** Sets `color: "#646464"`. */
  get gray700() {
    return this.add("color", "#646464");
  }
  /** Sets `color: "#353535"`. */
  get gray800() {
    return this.add("color", "#353535");
  }
  /** Sets `color: "#242424"`. */
  get gray900() {
    return this.add("color", "#242424");
  }
  /** Sets `color: "#ecfdf5"`. */
  get green50() {
    return this.add("color", "#ecfdf5");
  }
  /** Sets `color: "#d1fae5"`. */
  get green100() {
    return this.add("color", "#d1fae5");
  }
  /** Sets `color: "#a7f3d0"`. */
  get green200() {
    return this.add("color", "#a7f3d0");
  }
  /** Sets `color: "#6ee7b7"`. */
  get green300() {
    return this.add("color", "#6ee7b7");
  }
  /** Sets `color: "#34d399"`. */
  get green400() {
    return this.add("color", "#34d399");
  }
  /** Sets `color: "#10b981"`. */
  get green500() {
    return this.add("color", "#10b981");
  }
  /** Sets `color: "#059669"`. */
  get green600() {
    return this.add("color", "#059669");
  }
  /** Sets `color: "#047857"`. */
  get green700() {
    return this.add("color", "#047857");
  }
  /** Sets `color: "#065f46"`. */
  get green800() {
    return this.add("color", "#065f46");
  }
  /** Sets `color: "#064e3b"`. */
  get green900() {
    return this.add("color", "#064e3b");
  }
  /** Sets `color: "#f5f3ff"`. */
  get purple50() {
    return this.add("color", "#f5f3ff");
  }
  /** Sets `color: "#ede9fe"`. */
  get purple100() {
    return this.add("color", "#ede9fe");
  }
  /** Sets `color: "#ddd6fe"`. */
  get purple200() {
    return this.add("color", "#ddd6fe");
  }
  /** Sets `color: "#c4b5fd"`. */
  get purple300() {
    return this.add("color", "#c4b5fd");
  }
  /** Sets `color: "#a78bfa"`. */
  get purple400() {
    return this.add("color", "#a78bfa");
  }
  /** Sets `color: "#8b5cf6"`. */
  get purple500() {
    return this.add("color", "#8b5cf6");
  }
  /** Sets `color: "#7c3aed"`. */
  get purple600() {
    return this.add("color", "#7c3aed");
  }
  /** Sets `color: "#6d28d9"`. */
  get purple700() {
    return this.add("color", "#6d28d9");
  }
  /** Sets `color: "#5b21b6"`. */
  get purple800() {
    return this.add("color", "#5b21b6");
  }
  /** Sets `color: "#4c1d95"`. */
  get purple900() {
    return this.add("color", "#4c1d95");
  }
  /** Sets `color: "#DA1E28"`. */
  get redError() {
    return this.add("color", "#DA1E28");
  }
  /** Sets `color: "#fef2f2"`. */
  get red50() {
    return this.add("color", "#fef2f2");
  }
  /** Sets `color: "#fee2e2"`. */
  get red100() {
    return this.add("color", "#fee2e2");
  }
  /** Sets `color: "#fecaca"`. */
  get red200() {
    return this.add("color", "#fecaca");
  }
  /** Sets `color: "#fca5a5"`. */
  get red300() {
    return this.add("color", "#fca5a5");
  }
  /** Sets `color: "#f87171"`. */
  get red400() {
    return this.add("color", "#f87171");
  }
  /** Sets `color: "#ef4444"`. */
  get red500() {
    return this.add("color", "#ef4444");
  }
  /** Sets `color: "#c86251"`. */
  get red600() {
    return this.add("color", "#c86251");
  }
  /** Sets `color: "#b91c1c"`. */
  get red700() {
    return this.add("color", "#b91c1c");
  }
  /** Sets `color: "#991b1b"`. */
  get red800() {
    return this.add("color", "#991b1b");
  }
  /** Sets `color: "#7f1d1d"`. */
  get red900() {
    return this.add("color", "#7f1d1d");
  }
  /** Sets `color: "#fefce8"`. */
  get yellow50() {
    return this.add("color", "#fefce8");
  }
  /** Sets `color: "#fef9c3"`. */
  get yellow100() {
    return this.add("color", "#fef9c3");
  }
  /** Sets `color: "#fef08a"`. */
  get yellow200() {
    return this.add("color", "#fef08a");
  }
  /** Sets `color: "#fde047"`. */
  get yellow300() {
    return this.add("color", "#fde047");
  }
  /** Sets `color: "#facc15"`. */
  get yellow400() {
    return this.add("color", "#facc15");
  }
  /** Sets `color: "#eab308"`. */
  get yellow500() {
    return this.add("color", "#eab308");
  }
  /** Sets `color: "#ca8a04"`. */
  get yellow600() {
    return this.add("color", "#ca8a04");
  }
  /** Sets `color: "#a16207"`. */
  get yellow700() {
    return this.add("color", "#a16207");
  }
  /** Sets `color: "#854d0e"`. */
  get yellow800() {
    return this.add("color", "#854d0e");
  }
  /** Sets `color: "#713f12"`. */
  get yellow900() {
    return this.add("color", "#713f12");
  }
  /** Sets `color: "#eff6ff"`. */
  get blue50() {
    return this.add("color", "#eff6ff");
  }
  /** Sets `color: "#dbeafe"`. */
  get blue100() {
    return this.add("color", "#dbeafe");
  }
  /** Sets `color: "#bfdbfe"`. */
  get blue200() {
    return this.add("color", "#bfdbfe");
  }
  /** Sets `color: "#93c5fd"`. */
  get blue300() {
    return this.add("color", "#93c5fd");
  }
  /** Sets `color: "#60a5fa"`. */
  get blue400() {
    return this.add("color", "#60a5fa");
  }
  /** Sets `color: "#3b82f6"`. */
  get blue500() {
    return this.add("color", "#3b82f6");
  }
  /** Sets `color: "#2563eb"`. */
  get blue600() {
    return this.add("color", "#2563eb");
  }
  /** Sets `color: "#1d4ed8"`. */
  get blue700() {
    return this.add("color", "#1d4ed8");
  }
  /** Sets `color: "#1e40af"`. */
  get blue800() {
    return this.add("color", "#1e40af");
  }
  /** Sets `color: "#1e3a8a"`. */
  get blue900() {
    return this.add("color", "#1e3a8a");
  }
  /** Sets `color: "#fff7ed"`. */
  get orange50() {
    return this.add("color", "#fff7ed");
  }
  /** Sets `color: "#ffedd5"`. */
  get orange100() {
    return this.add("color", "#ffedd5");
  }
  /** Sets `color: "#fed7aa"`. */
  get orange200() {
    return this.add("color", "#fed7aa");
  }
  /** Sets `color: "#fdba74"`. */
  get orange300() {
    return this.add("color", "#fdba74");
  }
  /** Sets `color: "#fb923c"`. */
  get orange400() {
    return this.add("color", "#fb923c");
  }
  /** Sets `color: "#f97316"`. */
  get orange500() {
    return this.add("color", "#f97316");
  }
  /** Sets `color: "#ea580c"`. */
  get orange600() {
    return this.add("color", "#ea580c");
  }
  /** Sets `color: "#c2410c"`. */
  get orange700() {
    return this.add("color", "#c2410c");
  }
  /** Sets `color: "#9a3412"`. */
  get orange800() {
    return this.add("color", "#9a3412");
  }
  /** Sets `color: "#7c2d12"`. */
  get orange900() {
    return this.add("color", "#7c2d12");
  }
  /** Sets `color: value`. */
  color(value: Properties["color"]) {
    return this.add("color", value);
  }
  /** Sets `backgroundColor: "#FFFFFF"`. */
  get bgWhite() {
    return this.add("backgroundColor", "#FFFFFF");
  }
  /** Sets `backgroundColor: "#F6F6F0"`. */
  get bgOffWhite() {
    return this.add("backgroundColor", "#F6F6F0");
  }
  /** Sets `backgroundColor: "#000000"`. */
  get bgBlack() {
    return this.add("backgroundColor", "#000000");
  }
  /** Sets `backgroundColor: "#0067C5"`. */
  get bgbpBlue() {
    return this.add("backgroundColor", "#0067C5");
  }
  /** Sets `backgroundColor: "#EBEAE4FF"`. */
  get bgTaupe() {
    return this.add("backgroundColor", "#EBEAE4FF");
  }
  /** Sets `backgroundColor: "#888888"`. */
  get bgGray() {
    return this.add("backgroundColor", "#888888");
  }
  /** Sets `backgroundColor: "#00000000"`. */
  get bgTransparent() {
    return this.add("backgroundColor", "#00000000");
  }
  /** Sets `backgroundColor: "#000000B2"`. */
  get bgTranslucentBlack() {
    return this.add("backgroundColor", "#000000B2");
  }
  /** Sets `backgroundColor: "#F6B14E"`. */
  get bgBrightYellow() {
    return this.add("backgroundColor", "#F6B14E");
  }
  /** Sets `backgroundColor: "#AEB564"`. */
  get bgBrightGreen() {
    return this.add("backgroundColor", "#AEB564");
  }
  /** Sets `backgroundColor: "#3A759D"`. */
  get bgBrightBlue() {
    return this.add("backgroundColor", "#3A759D");
  }
  /** Sets `backgroundColor: "#C86251"`. */
  get bgBrightStrawberry() {
    return this.add("backgroundColor", "#C86251");
  }
  /** Sets `backgroundColor: "#8B514E"`. */
  get bgSaturatedWine() {
    return this.add("backgroundColor", "#8B514E");
  }
  /** Sets `backgroundColor: "#D17520"`. */
  get bgSaturatedOrange() {
    return this.add("backgroundColor", "#D17520");
  }
  /** Sets `backgroundColor: "#657839"`. */
  get bgSaturatedGrass() {
    return this.add("backgroundColor", "#657839");
  }
  /** Sets `backgroundColor: "#9CA084"`. */
  get bgMoss() {
    return this.add("backgroundColor", "#9CA084");
  }
  /** Sets `backgroundColor: "#5F477F"`. */
  get bgPlum() {
    return this.add("backgroundColor", "#5F477F");
  }
  /** Sets `backgroundColor: "#CECECE"`. */
  get bgLightGray() {
    return this.add("backgroundColor", "#CECECE");
  }
  /** Sets `backgroundColor: "#66666DFF"`. */
  get bgMidGray() {
    return this.add("backgroundColor", "#66666DFF");
  }
  /** Sets `backgroundColor: "#D2D7DD"`. */
  get bgLightBlue() {
    return this.add("backgroundColor", "#D2D7DD");
  }
  /** Sets `backgroundColor: "#F7E9D5"`. */
  get bgLightPeach() {
    return this.add("backgroundColor", "#F7E9D5");
  }
  /** Sets `backgroundColor: "#353535CC"`. */
  get bgGray80() {
    return this.add("backgroundColor", "#353535CC");
  }
  /** Sets `backgroundColor: "#3535350A"`. */
  get bgGray4() {
    return this.add("backgroundColor", "#3535350A");
  }
  /** Sets `backgroundColor: "#35353514"`. */
  get bgGray8() {
    return this.add("backgroundColor", "#35353514");
  }
  /** Sets `backgroundColor: "#35353529"`. */
  get bgGray16() {
    return this.add("backgroundColor", "#35353529");
  }
  /** Sets `backgroundColor: "#fffdfd"`. */
  get bgGray50() {
    return this.add("backgroundColor", "#fffdfd");
  }
  /** Sets `backgroundColor: "#F7F5F5"`. */
  get bgGray100() {
    return this.add("backgroundColor", "#F7F5F5");
  }
  /** Sets `backgroundColor: "#ECEBEB"`. */
  get bgGray200() {
    return this.add("backgroundColor", "#ECEBEB");
  }
  /** Sets `backgroundColor: "#DDDCDC"`. */
  get bgGray300() {
    return this.add("backgroundColor", "#DDDCDC");
  }
  /** Sets `backgroundColor: "#C9C9C9"`. */
  get bgGray400() {
    return this.add("backgroundColor", "#C9C9C9");
  }
  /** Sets `backgroundColor: "#AFAFAF"`. */
  get bgGray500() {
    return this.add("backgroundColor", "#AFAFAF");
  }
  /** Sets `backgroundColor: "#8D8D8D"`. */
  get bgGray600() {
    return this.add("backgroundColor", "#8D8D8D");
  }
  /** Sets `backgroundColor: "#646464"`. */
  get bgGray700() {
    return this.add("backgroundColor", "#646464");
  }
  /** Sets `backgroundColor: "#353535"`. */
  get bgGray800() {
    return this.add("backgroundColor", "#353535");
  }
  /** Sets `backgroundColor: "#242424"`. */
  get bgGray900() {
    return this.add("backgroundColor", "#242424");
  }
  /** Sets `backgroundColor: "#ecfdf5"`. */
  get bgGreen50() {
    return this.add("backgroundColor", "#ecfdf5");
  }
  /** Sets `backgroundColor: "#d1fae5"`. */
  get bgGreen100() {
    return this.add("backgroundColor", "#d1fae5");
  }
  /** Sets `backgroundColor: "#a7f3d0"`. */
  get bgGreen200() {
    return this.add("backgroundColor", "#a7f3d0");
  }
  /** Sets `backgroundColor: "#6ee7b7"`. */
  get bgGreen300() {
    return this.add("backgroundColor", "#6ee7b7");
  }
  /** Sets `backgroundColor: "#34d399"`. */
  get bgGreen400() {
    return this.add("backgroundColor", "#34d399");
  }
  /** Sets `backgroundColor: "#10b981"`. */
  get bgGreen500() {
    return this.add("backgroundColor", "#10b981");
  }
  /** Sets `backgroundColor: "#059669"`. */
  get bgGreen600() {
    return this.add("backgroundColor", "#059669");
  }
  /** Sets `backgroundColor: "#047857"`. */
  get bgGreen700() {
    return this.add("backgroundColor", "#047857");
  }
  /** Sets `backgroundColor: "#065f46"`. */
  get bgGreen800() {
    return this.add("backgroundColor", "#065f46");
  }
  /** Sets `backgroundColor: "#064e3b"`. */
  get bgGreen900() {
    return this.add("backgroundColor", "#064e3b");
  }
  /** Sets `backgroundColor: "#f5f3ff"`. */
  get bgPurple50() {
    return this.add("backgroundColor", "#f5f3ff");
  }
  /** Sets `backgroundColor: "#ede9fe"`. */
  get bgPurple100() {
    return this.add("backgroundColor", "#ede9fe");
  }
  /** Sets `backgroundColor: "#ddd6fe"`. */
  get bgPurple200() {
    return this.add("backgroundColor", "#ddd6fe");
  }
  /** Sets `backgroundColor: "#c4b5fd"`. */
  get bgPurple300() {
    return this.add("backgroundColor", "#c4b5fd");
  }
  /** Sets `backgroundColor: "#a78bfa"`. */
  get bgPurple400() {
    return this.add("backgroundColor", "#a78bfa");
  }
  /** Sets `backgroundColor: "#8b5cf6"`. */
  get bgPurple500() {
    return this.add("backgroundColor", "#8b5cf6");
  }
  /** Sets `backgroundColor: "#7c3aed"`. */
  get bgPurple600() {
    return this.add("backgroundColor", "#7c3aed");
  }
  /** Sets `backgroundColor: "#6d28d9"`. */
  get bgPurple700() {
    return this.add("backgroundColor", "#6d28d9");
  }
  /** Sets `backgroundColor: "#5b21b6"`. */
  get bgPurple800() {
    return this.add("backgroundColor", "#5b21b6");
  }
  /** Sets `backgroundColor: "#4c1d95"`. */
  get bgPurple900() {
    return this.add("backgroundColor", "#4c1d95");
  }
  /** Sets `backgroundColor: "#DA1E28"`. */
  get bgRedError() {
    return this.add("backgroundColor", "#DA1E28");
  }
  /** Sets `backgroundColor: "#fef2f2"`. */
  get bgRed50() {
    return this.add("backgroundColor", "#fef2f2");
  }
  /** Sets `backgroundColor: "#fee2e2"`. */
  get bgRed100() {
    return this.add("backgroundColor", "#fee2e2");
  }
  /** Sets `backgroundColor: "#fecaca"`. */
  get bgRed200() {
    return this.add("backgroundColor", "#fecaca");
  }
  /** Sets `backgroundColor: "#fca5a5"`. */
  get bgRed300() {
    return this.add("backgroundColor", "#fca5a5");
  }
  /** Sets `backgroundColor: "#f87171"`. */
  get bgRed400() {
    return this.add("backgroundColor", "#f87171");
  }
  /** Sets `backgroundColor: "#ef4444"`. */
  get bgRed500() {
    return this.add("backgroundColor", "#ef4444");
  }
  /** Sets `backgroundColor: "#c86251"`. */
  get bgRed600() {
    return this.add("backgroundColor", "#c86251");
  }
  /** Sets `backgroundColor: "#b91c1c"`. */
  get bgRed700() {
    return this.add("backgroundColor", "#b91c1c");
  }
  /** Sets `backgroundColor: "#991b1b"`. */
  get bgRed800() {
    return this.add("backgroundColor", "#991b1b");
  }
  /** Sets `backgroundColor: "#7f1d1d"`. */
  get bgRed900() {
    return this.add("backgroundColor", "#7f1d1d");
  }
  /** Sets `backgroundColor: "#fefce8"`. */
  get bgYellow50() {
    return this.add("backgroundColor", "#fefce8");
  }
  /** Sets `backgroundColor: "#fef9c3"`. */
  get bgYellow100() {
    return this.add("backgroundColor", "#fef9c3");
  }
  /** Sets `backgroundColor: "#fef08a"`. */
  get bgYellow200() {
    return this.add("backgroundColor", "#fef08a");
  }
  /** Sets `backgroundColor: "#fde047"`. */
  get bgYellow300() {
    return this.add("backgroundColor", "#fde047");
  }
  /** Sets `backgroundColor: "#facc15"`. */
  get bgYellow400() {
    return this.add("backgroundColor", "#facc15");
  }
  /** Sets `backgroundColor: "#eab308"`. */
  get bgYellow500() {
    return this.add("backgroundColor", "#eab308");
  }
  /** Sets `backgroundColor: "#ca8a04"`. */
  get bgYellow600() {
    return this.add("backgroundColor", "#ca8a04");
  }
  /** Sets `backgroundColor: "#a16207"`. */
  get bgYellow700() {
    return this.add("backgroundColor", "#a16207");
  }
  /** Sets `backgroundColor: "#854d0e"`. */
  get bgYellow800() {
    return this.add("backgroundColor", "#854d0e");
  }
  /** Sets `backgroundColor: "#713f12"`. */
  get bgYellow900() {
    return this.add("backgroundColor", "#713f12");
  }
  /** Sets `backgroundColor: "#eff6ff"`. */
  get bgBlue50() {
    return this.add("backgroundColor", "#eff6ff");
  }
  /** Sets `backgroundColor: "#dbeafe"`. */
  get bgBlue100() {
    return this.add("backgroundColor", "#dbeafe");
  }
  /** Sets `backgroundColor: "#bfdbfe"`. */
  get bgBlue200() {
    return this.add("backgroundColor", "#bfdbfe");
  }
  /** Sets `backgroundColor: "#93c5fd"`. */
  get bgBlue300() {
    return this.add("backgroundColor", "#93c5fd");
  }
  /** Sets `backgroundColor: "#60a5fa"`. */
  get bgBlue400() {
    return this.add("backgroundColor", "#60a5fa");
  }
  /** Sets `backgroundColor: "#3b82f6"`. */
  get bgBlue500() {
    return this.add("backgroundColor", "#3b82f6");
  }
  /** Sets `backgroundColor: "#2563eb"`. */
  get bgBlue600() {
    return this.add("backgroundColor", "#2563eb");
  }
  /** Sets `backgroundColor: "#1d4ed8"`. */
  get bgBlue700() {
    return this.add("backgroundColor", "#1d4ed8");
  }
  /** Sets `backgroundColor: "#1e40af"`. */
  get bgBlue800() {
    return this.add("backgroundColor", "#1e40af");
  }
  /** Sets `backgroundColor: "#1e3a8a"`. */
  get bgBlue900() {
    return this.add("backgroundColor", "#1e3a8a");
  }
  /** Sets `backgroundColor: "#fff7ed"`. */
  get bgOrange50() {
    return this.add("backgroundColor", "#fff7ed");
  }
  /** Sets `backgroundColor: "#ffedd5"`. */
  get bgOrange100() {
    return this.add("backgroundColor", "#ffedd5");
  }
  /** Sets `backgroundColor: "#fed7aa"`. */
  get bgOrange200() {
    return this.add("backgroundColor", "#fed7aa");
  }
  /** Sets `backgroundColor: "#fdba74"`. */
  get bgOrange300() {
    return this.add("backgroundColor", "#fdba74");
  }
  /** Sets `backgroundColor: "#fb923c"`. */
  get bgOrange400() {
    return this.add("backgroundColor", "#fb923c");
  }
  /** Sets `backgroundColor: "#f97316"`. */
  get bgOrange500() {
    return this.add("backgroundColor", "#f97316");
  }
  /** Sets `backgroundColor: "#ea580c"`. */
  get bgOrange600() {
    return this.add("backgroundColor", "#ea580c");
  }
  /** Sets `backgroundColor: "#c2410c"`. */
  get bgOrange700() {
    return this.add("backgroundColor", "#c2410c");
  }
  /** Sets `backgroundColor: "#9a3412"`. */
  get bgOrange800() {
    return this.add("backgroundColor", "#9a3412");
  }
  /** Sets `backgroundColor: "#7c2d12"`. */
  get bgOrange900() {
    return this.add("backgroundColor", "#7c2d12");
  }
  /** Sets `backgroundColor: value`. */
  bgColor(value: Properties["backgroundColor"]) {
    return this.add("backgroundColor", value);
  }
  /** Sets `fill: "#FFFFFF"`. */
  get fWhite() {
    return this.add("fill", "#FFFFFF");
  }
  /** Sets `fill: "#F6F6F0"`. */
  get fOffWhite() {
    return this.add("fill", "#F6F6F0");
  }
  /** Sets `fill: "#000000"`. */
  get fBlack() {
    return this.add("fill", "#000000");
  }
  /** Sets `fill: "#0067C5"`. */
  get fbpBlue() {
    return this.add("fill", "#0067C5");
  }
  /** Sets `fill: "#EBEAE4FF"`. */
  get fTaupe() {
    return this.add("fill", "#EBEAE4FF");
  }
  /** Sets `fill: "#888888"`. */
  get fGray() {
    return this.add("fill", "#888888");
  }
  /** Sets `fill: "#00000000"`. */
  get fTransparent() {
    return this.add("fill", "#00000000");
  }
  /** Sets `fill: "#000000B2"`. */
  get fTranslucentBlack() {
    return this.add("fill", "#000000B2");
  }
  /** Sets `fill: "#F6B14E"`. */
  get fBrightYellow() {
    return this.add("fill", "#F6B14E");
  }
  /** Sets `fill: "#AEB564"`. */
  get fBrightGreen() {
    return this.add("fill", "#AEB564");
  }
  /** Sets `fill: "#3A759D"`. */
  get fBrightBlue() {
    return this.add("fill", "#3A759D");
  }
  /** Sets `fill: "#C86251"`. */
  get fBrightStrawberry() {
    return this.add("fill", "#C86251");
  }
  /** Sets `fill: "#8B514E"`. */
  get fSaturatedWine() {
    return this.add("fill", "#8B514E");
  }
  /** Sets `fill: "#D17520"`. */
  get fSaturatedOrange() {
    return this.add("fill", "#D17520");
  }
  /** Sets `fill: "#657839"`. */
  get fSaturatedGrass() {
    return this.add("fill", "#657839");
  }
  /** Sets `fill: "#9CA084"`. */
  get fMoss() {
    return this.add("fill", "#9CA084");
  }
  /** Sets `fill: "#5F477F"`. */
  get fPlum() {
    return this.add("fill", "#5F477F");
  }
  /** Sets `fill: "#CECECE"`. */
  get fLightGray() {
    return this.add("fill", "#CECECE");
  }
  /** Sets `fill: "#66666DFF"`. */
  get fMidGray() {
    return this.add("fill", "#66666DFF");
  }
  /** Sets `fill: "#D2D7DD"`. */
  get fLightBlue() {
    return this.add("fill", "#D2D7DD");
  }
  /** Sets `fill: "#F7E9D5"`. */
  get fLightPeach() {
    return this.add("fill", "#F7E9D5");
  }
  /** Sets `fill: "#353535CC"`. */
  get fGray80() {
    return this.add("fill", "#353535CC");
  }
  /** Sets `fill: "#3535350A"`. */
  get fGray4() {
    return this.add("fill", "#3535350A");
  }
  /** Sets `fill: "#35353514"`. */
  get fGray8() {
    return this.add("fill", "#35353514");
  }
  /** Sets `fill: "#35353529"`. */
  get fGray16() {
    return this.add("fill", "#35353529");
  }
  /** Sets `fill: "#fffdfd"`. */
  get fGray50() {
    return this.add("fill", "#fffdfd");
  }
  /** Sets `fill: "#F7F5F5"`. */
  get fGray100() {
    return this.add("fill", "#F7F5F5");
  }
  /** Sets `fill: "#ECEBEB"`. */
  get fGray200() {
    return this.add("fill", "#ECEBEB");
  }
  /** Sets `fill: "#DDDCDC"`. */
  get fGray300() {
    return this.add("fill", "#DDDCDC");
  }
  /** Sets `fill: "#C9C9C9"`. */
  get fGray400() {
    return this.add("fill", "#C9C9C9");
  }
  /** Sets `fill: "#AFAFAF"`. */
  get fGray500() {
    return this.add("fill", "#AFAFAF");
  }
  /** Sets `fill: "#8D8D8D"`. */
  get fGray600() {
    return this.add("fill", "#8D8D8D");
  }
  /** Sets `fill: "#646464"`. */
  get fGray700() {
    return this.add("fill", "#646464");
  }
  /** Sets `fill: "#353535"`. */
  get fGray800() {
    return this.add("fill", "#353535");
  }
  /** Sets `fill: "#242424"`. */
  get fGray900() {
    return this.add("fill", "#242424");
  }
  /** Sets `fill: "#ecfdf5"`. */
  get fGreen50() {
    return this.add("fill", "#ecfdf5");
  }
  /** Sets `fill: "#d1fae5"`. */
  get fGreen100() {
    return this.add("fill", "#d1fae5");
  }
  /** Sets `fill: "#a7f3d0"`. */
  get fGreen200() {
    return this.add("fill", "#a7f3d0");
  }
  /** Sets `fill: "#6ee7b7"`. */
  get fGreen300() {
    return this.add("fill", "#6ee7b7");
  }
  /** Sets `fill: "#34d399"`. */
  get fGreen400() {
    return this.add("fill", "#34d399");
  }
  /** Sets `fill: "#10b981"`. */
  get fGreen500() {
    return this.add("fill", "#10b981");
  }
  /** Sets `fill: "#059669"`. */
  get fGreen600() {
    return this.add("fill", "#059669");
  }
  /** Sets `fill: "#047857"`. */
  get fGreen700() {
    return this.add("fill", "#047857");
  }
  /** Sets `fill: "#065f46"`. */
  get fGreen800() {
    return this.add("fill", "#065f46");
  }
  /** Sets `fill: "#064e3b"`. */
  get fGreen900() {
    return this.add("fill", "#064e3b");
  }
  /** Sets `fill: "#f5f3ff"`. */
  get fPurple50() {
    return this.add("fill", "#f5f3ff");
  }
  /** Sets `fill: "#ede9fe"`. */
  get fPurple100() {
    return this.add("fill", "#ede9fe");
  }
  /** Sets `fill: "#ddd6fe"`. */
  get fPurple200() {
    return this.add("fill", "#ddd6fe");
  }
  /** Sets `fill: "#c4b5fd"`. */
  get fPurple300() {
    return this.add("fill", "#c4b5fd");
  }
  /** Sets `fill: "#a78bfa"`. */
  get fPurple400() {
    return this.add("fill", "#a78bfa");
  }
  /** Sets `fill: "#8b5cf6"`. */
  get fPurple500() {
    return this.add("fill", "#8b5cf6");
  }
  /** Sets `fill: "#7c3aed"`. */
  get fPurple600() {
    return this.add("fill", "#7c3aed");
  }
  /** Sets `fill: "#6d28d9"`. */
  get fPurple700() {
    return this.add("fill", "#6d28d9");
  }
  /** Sets `fill: "#5b21b6"`. */
  get fPurple800() {
    return this.add("fill", "#5b21b6");
  }
  /** Sets `fill: "#4c1d95"`. */
  get fPurple900() {
    return this.add("fill", "#4c1d95");
  }
  /** Sets `fill: "#DA1E28"`. */
  get fRedError() {
    return this.add("fill", "#DA1E28");
  }
  /** Sets `fill: "#fef2f2"`. */
  get fRed50() {
    return this.add("fill", "#fef2f2");
  }
  /** Sets `fill: "#fee2e2"`. */
  get fRed100() {
    return this.add("fill", "#fee2e2");
  }
  /** Sets `fill: "#fecaca"`. */
  get fRed200() {
    return this.add("fill", "#fecaca");
  }
  /** Sets `fill: "#fca5a5"`. */
  get fRed300() {
    return this.add("fill", "#fca5a5");
  }
  /** Sets `fill: "#f87171"`. */
  get fRed400() {
    return this.add("fill", "#f87171");
  }
  /** Sets `fill: "#ef4444"`. */
  get fRed500() {
    return this.add("fill", "#ef4444");
  }
  /** Sets `fill: "#c86251"`. */
  get fRed600() {
    return this.add("fill", "#c86251");
  }
  /** Sets `fill: "#b91c1c"`. */
  get fRed700() {
    return this.add("fill", "#b91c1c");
  }
  /** Sets `fill: "#991b1b"`. */
  get fRed800() {
    return this.add("fill", "#991b1b");
  }
  /** Sets `fill: "#7f1d1d"`. */
  get fRed900() {
    return this.add("fill", "#7f1d1d");
  }
  /** Sets `fill: "#fefce8"`. */
  get fYellow50() {
    return this.add("fill", "#fefce8");
  }
  /** Sets `fill: "#fef9c3"`. */
  get fYellow100() {
    return this.add("fill", "#fef9c3");
  }
  /** Sets `fill: "#fef08a"`. */
  get fYellow200() {
    return this.add("fill", "#fef08a");
  }
  /** Sets `fill: "#fde047"`. */
  get fYellow300() {
    return this.add("fill", "#fde047");
  }
  /** Sets `fill: "#facc15"`. */
  get fYellow400() {
    return this.add("fill", "#facc15");
  }
  /** Sets `fill: "#eab308"`. */
  get fYellow500() {
    return this.add("fill", "#eab308");
  }
  /** Sets `fill: "#ca8a04"`. */
  get fYellow600() {
    return this.add("fill", "#ca8a04");
  }
  /** Sets `fill: "#a16207"`. */
  get fYellow700() {
    return this.add("fill", "#a16207");
  }
  /** Sets `fill: "#854d0e"`. */
  get fYellow800() {
    return this.add("fill", "#854d0e");
  }
  /** Sets `fill: "#713f12"`. */
  get fYellow900() {
    return this.add("fill", "#713f12");
  }
  /** Sets `fill: "#eff6ff"`. */
  get fBlue50() {
    return this.add("fill", "#eff6ff");
  }
  /** Sets `fill: "#dbeafe"`. */
  get fBlue100() {
    return this.add("fill", "#dbeafe");
  }
  /** Sets `fill: "#bfdbfe"`. */
  get fBlue200() {
    return this.add("fill", "#bfdbfe");
  }
  /** Sets `fill: "#93c5fd"`. */
  get fBlue300() {
    return this.add("fill", "#93c5fd");
  }
  /** Sets `fill: "#60a5fa"`. */
  get fBlue400() {
    return this.add("fill", "#60a5fa");
  }
  /** Sets `fill: "#3b82f6"`. */
  get fBlue500() {
    return this.add("fill", "#3b82f6");
  }
  /** Sets `fill: "#2563eb"`. */
  get fBlue600() {
    return this.add("fill", "#2563eb");
  }
  /** Sets `fill: "#1d4ed8"`. */
  get fBlue700() {
    return this.add("fill", "#1d4ed8");
  }
  /** Sets `fill: "#1e40af"`. */
  get fBlue800() {
    return this.add("fill", "#1e40af");
  }
  /** Sets `fill: "#1e3a8a"`. */
  get fBlue900() {
    return this.add("fill", "#1e3a8a");
  }
  /** Sets `fill: "#fff7ed"`. */
  get fOrange50() {
    return this.add("fill", "#fff7ed");
  }
  /** Sets `fill: "#ffedd5"`. */
  get fOrange100() {
    return this.add("fill", "#ffedd5");
  }
  /** Sets `fill: "#fed7aa"`. */
  get fOrange200() {
    return this.add("fill", "#fed7aa");
  }
  /** Sets `fill: "#fdba74"`. */
  get fOrange300() {
    return this.add("fill", "#fdba74");
  }
  /** Sets `fill: "#fb923c"`. */
  get fOrange400() {
    return this.add("fill", "#fb923c");
  }
  /** Sets `fill: "#f97316"`. */
  get fOrange500() {
    return this.add("fill", "#f97316");
  }
  /** Sets `fill: "#ea580c"`. */
  get fOrange600() {
    return this.add("fill", "#ea580c");
  }
  /** Sets `fill: "#c2410c"`. */
  get fOrange700() {
    return this.add("fill", "#c2410c");
  }
  /** Sets `fill: "#9a3412"`. */
  get fOrange800() {
    return this.add("fill", "#9a3412");
  }
  /** Sets `fill: "#7c2d12"`. */
  get fOrange900() {
    return this.add("fill", "#7c2d12");
  }
  /** Sets `fill: value`. */
  fill(value: Properties["fill"]) {
    return this.add("fill", value);
  }

  // spacing
  /** Sets `marginTop: "0px"`. */
  get mt0() {
    return this.add("marginTop", "0px");
  }
  /** Sets `marginTop: "8px"`. */
  get mt1() {
    return this.add("marginTop", "8px");
  }
  /** Sets `marginTop: "16px"`. */
  get mt2() {
    return this.add("marginTop", "16px");
  }
  /** Sets `marginTop: "24px"`. */
  get mt3() {
    return this.add("marginTop", "24px");
  }
  /** Sets `marginTop: "32px"`. */
  get mt4() {
    return this.add("marginTop", "32px");
  }
  /** Sets `marginTop: "40px"`. */
  get mt5() {
    return this.add("marginTop", "40px");
  }
  /** Sets `marginTop: "48px"`. */
  get mt6() {
    return this.add("marginTop", "48px");
  }
  /** Sets `marginTop: "56px"`. */
  get mt7() {
    return this.add("marginTop", "56px");
  }
  /** Sets `marginTop: "64px"`. */
  get mt8() {
    return this.add("marginTop", "64px");
  }
  /** Sets `marginTop: "auto"`. */
  get mta() {
    return this.add("marginTop", "auto");
  }
  /** Sets `marginTop: "v"`. */
  mt(v: number | string) {
    return this.add("marginTop", maybeInc(v));
  }
  /** Sets `marginTop: px`. */
  mtPx(px: number) {
    return this.add("marginTop", `${px}px`);
  }
  /** Sets `marginRight: "0px"`. */
  get mr0() {
    return this.add("marginRight", "0px");
  }
  /** Sets `marginRight: "8px"`. */
  get mr1() {
    return this.add("marginRight", "8px");
  }
  /** Sets `marginRight: "16px"`. */
  get mr2() {
    return this.add("marginRight", "16px");
  }
  /** Sets `marginRight: "24px"`. */
  get mr3() {
    return this.add("marginRight", "24px");
  }
  /** Sets `marginRight: "32px"`. */
  get mr4() {
    return this.add("marginRight", "32px");
  }
  /** Sets `marginRight: "40px"`. */
  get mr5() {
    return this.add("marginRight", "40px");
  }
  /** Sets `marginRight: "48px"`. */
  get mr6() {
    return this.add("marginRight", "48px");
  }
  /** Sets `marginRight: "56px"`. */
  get mr7() {
    return this.add("marginRight", "56px");
  }
  /** Sets `marginRight: "64px"`. */
  get mr8() {
    return this.add("marginRight", "64px");
  }
  /** Sets `marginRight: "auto"`. */
  get mra() {
    return this.add("marginRight", "auto");
  }
  /** Sets `marginRight: "v"`. */
  mr(v: number | string) {
    return this.add("marginRight", maybeInc(v));
  }
  /** Sets `marginRight: px`. */
  mrPx(px: number) {
    return this.add("marginRight", `${px}px`);
  }
  /** Sets `marginBottom: "0px"`. */
  get mb0() {
    return this.add("marginBottom", "0px");
  }
  /** Sets `marginBottom: "8px"`. */
  get mb1() {
    return this.add("marginBottom", "8px");
  }
  /** Sets `marginBottom: "16px"`. */
  get mb2() {
    return this.add("marginBottom", "16px");
  }
  /** Sets `marginBottom: "24px"`. */
  get mb3() {
    return this.add("marginBottom", "24px");
  }
  /** Sets `marginBottom: "32px"`. */
  get mb4() {
    return this.add("marginBottom", "32px");
  }
  /** Sets `marginBottom: "40px"`. */
  get mb5() {
    return this.add("marginBottom", "40px");
  }
  /** Sets `marginBottom: "48px"`. */
  get mb6() {
    return this.add("marginBottom", "48px");
  }
  /** Sets `marginBottom: "56px"`. */
  get mb7() {
    return this.add("marginBottom", "56px");
  }
  /** Sets `marginBottom: "64px"`. */
  get mb8() {
    return this.add("marginBottom", "64px");
  }
  /** Sets `marginBottom: "auto"`. */
  get mba() {
    return this.add("marginBottom", "auto");
  }
  /** Sets `marginBottom: "v"`. */
  mb(v: number | string) {
    return this.add("marginBottom", maybeInc(v));
  }
  /** Sets `marginBottom: px`. */
  mbPx(px: number) {
    return this.add("marginBottom", `${px}px`);
  }
  /** Sets `marginLeft: "0px"`. */
  get ml0() {
    return this.add("marginLeft", "0px");
  }
  /** Sets `marginLeft: "8px"`. */
  get ml1() {
    return this.add("marginLeft", "8px");
  }
  /** Sets `marginLeft: "16px"`. */
  get ml2() {
    return this.add("marginLeft", "16px");
  }
  /** Sets `marginLeft: "24px"`. */
  get ml3() {
    return this.add("marginLeft", "24px");
  }
  /** Sets `marginLeft: "32px"`. */
  get ml4() {
    return this.add("marginLeft", "32px");
  }
  /** Sets `marginLeft: "40px"`. */
  get ml5() {
    return this.add("marginLeft", "40px");
  }
  /** Sets `marginLeft: "48px"`. */
  get ml6() {
    return this.add("marginLeft", "48px");
  }
  /** Sets `marginLeft: "56px"`. */
  get ml7() {
    return this.add("marginLeft", "56px");
  }
  /** Sets `marginLeft: "64px"`. */
  get ml8() {
    return this.add("marginLeft", "64px");
  }
  /** Sets `marginLeft: "auto"`. */
  get mla() {
    return this.add("marginLeft", "auto");
  }
  /** Sets `marginLeft: "v"`. */
  ml(v: number | string) {
    return this.add("marginLeft", maybeInc(v));
  }
  /** Sets `marginLeft: px`. */
  mlPx(px: number) {
    return this.add("marginLeft", `${px}px`);
  }
  /** Sets `marginLeft: "0px"; marginRight: "0px"`. */
  get mx0() {
    return this.add("marginLeft", "0px").add("marginRight", "0px");
  }
  /** Sets `marginLeft: "8px"; marginRight: "8px"`. */
  get mx1() {
    return this.add("marginLeft", "8px").add("marginRight", "8px");
  }
  /** Sets `marginLeft: "16px"; marginRight: "16px"`. */
  get mx2() {
    return this.add("marginLeft", "16px").add("marginRight", "16px");
  }
  /** Sets `marginLeft: "24px"; marginRight: "24px"`. */
  get mx3() {
    return this.add("marginLeft", "24px").add("marginRight", "24px");
  }
  /** Sets `marginLeft: "32px"; marginRight: "32px"`. */
  get mx4() {
    return this.add("marginLeft", "32px").add("marginRight", "32px");
  }
  /** Sets `marginLeft: "40px"; marginRight: "40px"`. */
  get mx5() {
    return this.add("marginLeft", "40px").add("marginRight", "40px");
  }
  /** Sets `marginLeft: "48px"; marginRight: "48px"`. */
  get mx6() {
    return this.add("marginLeft", "48px").add("marginRight", "48px");
  }
  /** Sets `marginLeft: "56px"; marginRight: "56px"`. */
  get mx7() {
    return this.add("marginLeft", "56px").add("marginRight", "56px");
  }
  /** Sets `marginLeft: "64px"; marginRight: "64px"`. */
  get mx8() {
    return this.add("marginLeft", "64px").add("marginRight", "64px");
  }
  /** Sets `marginLeft: "auto"; marginRight: "auto"`. */
  get mxa() {
    return this.add("marginLeft", "auto").add("marginRight", "auto");
  }
  /** Sets `marginLeft: "v"; marginRight: "v"`. */
  mx(v: number | string) {
    return this.add("marginLeft", maybeInc(v)).add("marginRight", maybeInc(v));
  }
  /** Sets `marginLeft: px; marginRight: px`. */
  mxPx(px: number) {
    return this.add("marginLeft", `${px}px`).add("marginRight", `${px}px`);
  }
  /** Sets `marginTop: "0px"; marginBottom: "0px"`. */
  get my0() {
    return this.add("marginTop", "0px").add("marginBottom", "0px");
  }
  /** Sets `marginTop: "8px"; marginBottom: "8px"`. */
  get my1() {
    return this.add("marginTop", "8px").add("marginBottom", "8px");
  }
  /** Sets `marginTop: "16px"; marginBottom: "16px"`. */
  get my2() {
    return this.add("marginTop", "16px").add("marginBottom", "16px");
  }
  /** Sets `marginTop: "24px"; marginBottom: "24px"`. */
  get my3() {
    return this.add("marginTop", "24px").add("marginBottom", "24px");
  }
  /** Sets `marginTop: "32px"; marginBottom: "32px"`. */
  get my4() {
    return this.add("marginTop", "32px").add("marginBottom", "32px");
  }
  /** Sets `marginTop: "40px"; marginBottom: "40px"`. */
  get my5() {
    return this.add("marginTop", "40px").add("marginBottom", "40px");
  }
  /** Sets `marginTop: "48px"; marginBottom: "48px"`. */
  get my6() {
    return this.add("marginTop", "48px").add("marginBottom", "48px");
  }
  /** Sets `marginTop: "56px"; marginBottom: "56px"`. */
  get my7() {
    return this.add("marginTop", "56px").add("marginBottom", "56px");
  }
  /** Sets `marginTop: "64px"; marginBottom: "64px"`. */
  get my8() {
    return this.add("marginTop", "64px").add("marginBottom", "64px");
  }
  /** Sets `marginTop: "auto"; marginBottom: "auto"`. */
  get mya() {
    return this.add("marginTop", "auto").add("marginBottom", "auto");
  }
  /** Sets `marginTop: "v"; marginBottom: "v"`. */
  my(v: number | string) {
    return this.add("marginTop", maybeInc(v)).add("marginBottom", maybeInc(v));
  }
  /** Sets `marginTop: px; marginBottom: px`. */
  myPx(px: number) {
    return this.add("marginTop", `${px}px`).add("marginBottom", `${px}px`);
  }
  /** Sets `marginTop: "0px"; marginBottom: "0px"; marginRight: "0px"; marginLeft: "0px"`. */
  get m0() {
    return this.add("marginTop", "0px").add("marginBottom", "0px").add("marginRight", "0px").add("marginLeft", "0px");
  }
  /** Sets `marginTop: "8px"; marginBottom: "8px"; marginRight: "8px"; marginLeft: "8px"`. */
  get m1() {
    return this.add("marginTop", "8px").add("marginBottom", "8px").add("marginRight", "8px").add("marginLeft", "8px");
  }
  /** Sets `marginTop: "16px"; marginBottom: "16px"; marginRight: "16px"; marginLeft: "16px"`. */
  get m2() {
    return this.add("marginTop", "16px").add("marginBottom", "16px").add("marginRight", "16px").add(
      "marginLeft",
      "16px",
    );
  }
  /** Sets `marginTop: "24px"; marginBottom: "24px"; marginRight: "24px"; marginLeft: "24px"`. */
  get m3() {
    return this.add("marginTop", "24px").add("marginBottom", "24px").add("marginRight", "24px").add(
      "marginLeft",
      "24px",
    );
  }
  /** Sets `marginTop: "32px"; marginBottom: "32px"; marginRight: "32px"; marginLeft: "32px"`. */
  get m4() {
    return this.add("marginTop", "32px").add("marginBottom", "32px").add("marginRight", "32px").add(
      "marginLeft",
      "32px",
    );
  }
  /** Sets `marginTop: "40px"; marginBottom: "40px"; marginRight: "40px"; marginLeft: "40px"`. */
  get m5() {
    return this.add("marginTop", "40px").add("marginBottom", "40px").add("marginRight", "40px").add(
      "marginLeft",
      "40px",
    );
  }
  /** Sets `marginTop: "48px"; marginBottom: "48px"; marginRight: "48px"; marginLeft: "48px"`. */
  get m6() {
    return this.add("marginTop", "48px").add("marginBottom", "48px").add("marginRight", "48px").add(
      "marginLeft",
      "48px",
    );
  }
  /** Sets `marginTop: "56px"; marginBottom: "56px"; marginRight: "56px"; marginLeft: "56px"`. */
  get m7() {
    return this.add("marginTop", "56px").add("marginBottom", "56px").add("marginRight", "56px").add(
      "marginLeft",
      "56px",
    );
  }
  /** Sets `marginTop: "64px"; marginBottom: "64px"; marginRight: "64px"; marginLeft: "64px"`. */
  get m8() {
    return this.add("marginTop", "64px").add("marginBottom", "64px").add("marginRight", "64px").add(
      "marginLeft",
      "64px",
    );
  }
  /** Sets `marginTop: "auto"; marginBottom: "auto"; marginRight: "auto"; marginLeft: "auto"`. */
  get ma() {
    return this.add("marginTop", "auto").add("marginBottom", "auto").add("marginRight", "auto").add(
      "marginLeft",
      "auto",
    );
  }
  /** Sets `marginTop: "v"; marginBottom: "v"; marginRight: "v"; marginLeft: "v"`. */
  m(v: number | string) {
    return this.add("marginTop", maybeInc(v)).add("marginBottom", maybeInc(v)).add("marginRight", maybeInc(v)).add(
      "marginLeft",
      maybeInc(v),
    );
  }
  /** Sets `marginTop: px; marginBottom: px; marginRight: px; marginLeft: px`. */
  mPx(px: number) {
    return this.add("marginTop", `${px}px`).add("marginBottom", `${px}px`).add("marginRight", `${px}px`).add(
      "marginLeft",
      `${px}px`,
    );
  }
  /** Sets `paddingTop: "0px"`. */
  get pt0() {
    return this.add("paddingTop", "0px");
  }
  /** Sets `paddingTop: "8px"`. */
  get pt1() {
    return this.add("paddingTop", "8px");
  }
  /** Sets `paddingTop: "16px"`. */
  get pt2() {
    return this.add("paddingTop", "16px");
  }
  /** Sets `paddingTop: "24px"`. */
  get pt3() {
    return this.add("paddingTop", "24px");
  }
  /** Sets `paddingTop: "32px"`. */
  get pt4() {
    return this.add("paddingTop", "32px");
  }
  /** Sets `paddingTop: "40px"`. */
  get pt5() {
    return this.add("paddingTop", "40px");
  }
  /** Sets `paddingTop: "48px"`. */
  get pt6() {
    return this.add("paddingTop", "48px");
  }
  /** Sets `paddingTop: "56px"`. */
  get pt7() {
    return this.add("paddingTop", "56px");
  }
  /** Sets `paddingTop: "64px"`. */
  get pt8() {
    return this.add("paddingTop", "64px");
  }
  /** Sets `paddingTop: "v"`. */
  pt(v: number | string) {
    return this.add("paddingTop", maybeInc(v));
  }
  /** Sets `paddingTop: px`. */
  ptPx(px: number) {
    return this.add("paddingTop", `${px}px`);
  }
  /** Sets `paddingRight: "0px"`. */
  get pr0() {
    return this.add("paddingRight", "0px");
  }
  /** Sets `paddingRight: "8px"`. */
  get pr1() {
    return this.add("paddingRight", "8px");
  }
  /** Sets `paddingRight: "16px"`. */
  get pr2() {
    return this.add("paddingRight", "16px");
  }
  /** Sets `paddingRight: "24px"`. */
  get pr3() {
    return this.add("paddingRight", "24px");
  }
  /** Sets `paddingRight: "32px"`. */
  get pr4() {
    return this.add("paddingRight", "32px");
  }
  /** Sets `paddingRight: "40px"`. */
  get pr5() {
    return this.add("paddingRight", "40px");
  }
  /** Sets `paddingRight: "48px"`. */
  get pr6() {
    return this.add("paddingRight", "48px");
  }
  /** Sets `paddingRight: "56px"`. */
  get pr7() {
    return this.add("paddingRight", "56px");
  }
  /** Sets `paddingRight: "64px"`. */
  get pr8() {
    return this.add("paddingRight", "64px");
  }
  /** Sets `paddingRight: "v"`. */
  pr(v: number | string) {
    return this.add("paddingRight", maybeInc(v));
  }
  /** Sets `paddingRight: px`. */
  prPx(px: number) {
    return this.add("paddingRight", `${px}px`);
  }
  /** Sets `paddingBottom: "0px"`. */
  get pb0() {
    return this.add("paddingBottom", "0px");
  }
  /** Sets `paddingBottom: "8px"`. */
  get pb1() {
    return this.add("paddingBottom", "8px");
  }
  /** Sets `paddingBottom: "16px"`. */
  get pb2() {
    return this.add("paddingBottom", "16px");
  }
  /** Sets `paddingBottom: "24px"`. */
  get pb3() {
    return this.add("paddingBottom", "24px");
  }
  /** Sets `paddingBottom: "32px"`. */
  get pb4() {
    return this.add("paddingBottom", "32px");
  }
  /** Sets `paddingBottom: "40px"`. */
  get pb5() {
    return this.add("paddingBottom", "40px");
  }
  /** Sets `paddingBottom: "48px"`. */
  get pb6() {
    return this.add("paddingBottom", "48px");
  }
  /** Sets `paddingBottom: "56px"`. */
  get pb7() {
    return this.add("paddingBottom", "56px");
  }
  /** Sets `paddingBottom: "64px"`. */
  get pb8() {
    return this.add("paddingBottom", "64px");
  }
  /** Sets `paddingBottom: "v"`. */
  pb(v: number | string) {
    return this.add("paddingBottom", maybeInc(v));
  }
  /** Sets `paddingBottom: px`. */
  pbPx(px: number) {
    return this.add("paddingBottom", `${px}px`);
  }
  /** Sets `paddingLeft: "0px"`. */
  get pl0() {
    return this.add("paddingLeft", "0px");
  }
  /** Sets `paddingLeft: "8px"`. */
  get pl1() {
    return this.add("paddingLeft", "8px");
  }
  /** Sets `paddingLeft: "16px"`. */
  get pl2() {
    return this.add("paddingLeft", "16px");
  }
  /** Sets `paddingLeft: "24px"`. */
  get pl3() {
    return this.add("paddingLeft", "24px");
  }
  /** Sets `paddingLeft: "32px"`. */
  get pl4() {
    return this.add("paddingLeft", "32px");
  }
  /** Sets `paddingLeft: "40px"`. */
  get pl5() {
    return this.add("paddingLeft", "40px");
  }
  /** Sets `paddingLeft: "48px"`. */
  get pl6() {
    return this.add("paddingLeft", "48px");
  }
  /** Sets `paddingLeft: "56px"`. */
  get pl7() {
    return this.add("paddingLeft", "56px");
  }
  /** Sets `paddingLeft: "64px"`. */
  get pl8() {
    return this.add("paddingLeft", "64px");
  }
  /** Sets `paddingLeft: "v"`. */
  pl(v: number | string) {
    return this.add("paddingLeft", maybeInc(v));
  }
  /** Sets `paddingLeft: px`. */
  plPx(px: number) {
    return this.add("paddingLeft", `${px}px`);
  }
  /** Sets `paddingLeft: "0px"; paddingRight: "0px"`. */
  get px0() {
    return this.add("paddingLeft", "0px").add("paddingRight", "0px");
  }
  /** Sets `paddingLeft: "8px"; paddingRight: "8px"`. */
  get px1() {
    return this.add("paddingLeft", "8px").add("paddingRight", "8px");
  }
  /** Sets `paddingLeft: "16px"; paddingRight: "16px"`. */
  get px2() {
    return this.add("paddingLeft", "16px").add("paddingRight", "16px");
  }
  /** Sets `paddingLeft: "24px"; paddingRight: "24px"`. */
  get px3() {
    return this.add("paddingLeft", "24px").add("paddingRight", "24px");
  }
  /** Sets `paddingLeft: "32px"; paddingRight: "32px"`. */
  get px4() {
    return this.add("paddingLeft", "32px").add("paddingRight", "32px");
  }
  /** Sets `paddingLeft: "40px"; paddingRight: "40px"`. */
  get px5() {
    return this.add("paddingLeft", "40px").add("paddingRight", "40px");
  }
  /** Sets `paddingLeft: "48px"; paddingRight: "48px"`. */
  get px6() {
    return this.add("paddingLeft", "48px").add("paddingRight", "48px");
  }
  /** Sets `paddingLeft: "56px"; paddingRight: "56px"`. */
  get px7() {
    return this.add("paddingLeft", "56px").add("paddingRight", "56px");
  }
  /** Sets `paddingLeft: "64px"; paddingRight: "64px"`. */
  get px8() {
    return this.add("paddingLeft", "64px").add("paddingRight", "64px");
  }
  /** Sets `paddingLeft: "v"; paddingRight: "v"`. */
  px(v: number | string) {
    return this.add("paddingLeft", maybeInc(v)).add("paddingRight", maybeInc(v));
  }
  /** Sets `paddingLeft: px; paddingRight: px`. */
  pxPx(px: number) {
    return this.add("paddingLeft", `${px}px`).add("paddingRight", `${px}px`);
  }
  /** Sets `paddingTop: "0px"; paddingBottom: "0px"`. */
  get py0() {
    return this.add("paddingTop", "0px").add("paddingBottom", "0px");
  }
  /** Sets `paddingTop: "8px"; paddingBottom: "8px"`. */
  get py1() {
    return this.add("paddingTop", "8px").add("paddingBottom", "8px");
  }
  /** Sets `paddingTop: "16px"; paddingBottom: "16px"`. */
  get py2() {
    return this.add("paddingTop", "16px").add("paddingBottom", "16px");
  }
  /** Sets `paddingTop: "24px"; paddingBottom: "24px"`. */
  get py3() {
    return this.add("paddingTop", "24px").add("paddingBottom", "24px");
  }
  /** Sets `paddingTop: "32px"; paddingBottom: "32px"`. */
  get py4() {
    return this.add("paddingTop", "32px").add("paddingBottom", "32px");
  }
  /** Sets `paddingTop: "40px"; paddingBottom: "40px"`. */
  get py5() {
    return this.add("paddingTop", "40px").add("paddingBottom", "40px");
  }
  /** Sets `paddingTop: "48px"; paddingBottom: "48px"`. */
  get py6() {
    return this.add("paddingTop", "48px").add("paddingBottom", "48px");
  }
  /** Sets `paddingTop: "56px"; paddingBottom: "56px"`. */
  get py7() {
    return this.add("paddingTop", "56px").add("paddingBottom", "56px");
  }
  /** Sets `paddingTop: "64px"; paddingBottom: "64px"`. */
  get py8() {
    return this.add("paddingTop", "64px").add("paddingBottom", "64px");
  }
  /** Sets `paddingTop: "v"; paddingBottom: "v"`. */
  py(v: number | string) {
    return this.add("paddingTop", maybeInc(v)).add("paddingBottom", maybeInc(v));
  }
  /** Sets `paddingTop: px; paddingBottom: px`. */
  pyPx(px: number) {
    return this.add("paddingTop", `${px}px`).add("paddingBottom", `${px}px`);
  }
  /** Sets `paddingTop: "0px"; paddingBottom: "0px"; paddingRight: "0px"; paddingLeft: "0px"`. */
  get p0() {
    return this.add("paddingTop", "0px").add("paddingBottom", "0px").add("paddingRight", "0px").add(
      "paddingLeft",
      "0px",
    );
  }
  /** Sets `paddingTop: "8px"; paddingBottom: "8px"; paddingRight: "8px"; paddingLeft: "8px"`. */
  get p1() {
    return this.add("paddingTop", "8px").add("paddingBottom", "8px").add("paddingRight", "8px").add(
      "paddingLeft",
      "8px",
    );
  }
  /** Sets `paddingTop: "16px"; paddingBottom: "16px"; paddingRight: "16px"; paddingLeft: "16px"`. */
  get p2() {
    return this.add("paddingTop", "16px").add("paddingBottom", "16px").add("paddingRight", "16px").add(
      "paddingLeft",
      "16px",
    );
  }
  /** Sets `paddingTop: "24px"; paddingBottom: "24px"; paddingRight: "24px"; paddingLeft: "24px"`. */
  get p3() {
    return this.add("paddingTop", "24px").add("paddingBottom", "24px").add("paddingRight", "24px").add(
      "paddingLeft",
      "24px",
    );
  }
  /** Sets `paddingTop: "32px"; paddingBottom: "32px"; paddingRight: "32px"; paddingLeft: "32px"`. */
  get p4() {
    return this.add("paddingTop", "32px").add("paddingBottom", "32px").add("paddingRight", "32px").add(
      "paddingLeft",
      "32px",
    );
  }
  /** Sets `paddingTop: "40px"; paddingBottom: "40px"; paddingRight: "40px"; paddingLeft: "40px"`. */
  get p5() {
    return this.add("paddingTop", "40px").add("paddingBottom", "40px").add("paddingRight", "40px").add(
      "paddingLeft",
      "40px",
    );
  }
  /** Sets `paddingTop: "48px"; paddingBottom: "48px"; paddingRight: "48px"; paddingLeft: "48px"`. */
  get p6() {
    return this.add("paddingTop", "48px").add("paddingBottom", "48px").add("paddingRight", "48px").add(
      "paddingLeft",
      "48px",
    );
  }
  /** Sets `paddingTop: "56px"; paddingBottom: "56px"; paddingRight: "56px"; paddingLeft: "56px"`. */
  get p7() {
    return this.add("paddingTop", "56px").add("paddingBottom", "56px").add("paddingRight", "56px").add(
      "paddingLeft",
      "56px",
    );
  }
  /** Sets `paddingTop: "64px"; paddingBottom: "64px"; paddingRight: "64px"; paddingLeft: "64px"`. */
  get p8() {
    return this.add("paddingTop", "64px").add("paddingBottom", "64px").add("paddingRight", "64px").add(
      "paddingLeft",
      "64px",
    );
  }
  /** Sets `paddingTop: "v"; paddingBottom: "v"; paddingRight: "v"; paddingLeft: "v"`. */
  p(v: number | string) {
    return this.add("paddingTop", maybeInc(v)).add("paddingBottom", maybeInc(v)).add("paddingRight", maybeInc(v)).add(
      "paddingLeft",
      maybeInc(v),
    );
  }
  /** Sets `paddingTop: px; paddingBottom: px; paddingRight: px; paddingLeft: px`. */
  pPx(px: number) {
    return this.add("paddingTop", `${px}px`).add("paddingBottom", `${px}px`).add("paddingRight", `${px}px`).add(
      "paddingLeft",
      `${px}px`,
    );
  }

  // textAlign
  /** Sets `textAlign: "left"`. */
  get tal() {
    return this.add("textAlign", "left");
  }
  /** Sets `textAlign: "center"`. */
  get tac() {
    return this.add("textAlign", "center");
  }
  /** Sets `textAlign: "right"`. */
  get tar() {
    return this.add("textAlign", "right");
  }
  /** Sets `textAlign: "justify"`. */
  get taj() {
    return this.add("textAlign", "justify");
  }
  /** Sets `textAlign: value`. */
  ta(value: Properties["textAlign"]) {
    return this.add("textAlign", value);
  }

  // textDecoration
  /** Sets `textDecoration: "none"`. */
  get tdn() {
    return this.add("textDecoration", "none");
  }
  /** Sets `textDecoration: "line-through"`. */
  get tdlt() {
    return this.add("textDecoration", "line-through");
  }
  /** Sets `textDecoration: "underline"`. */
  get tdu() {
    return this.add("textDecoration", "underline");
  }
  /** Sets `textDecoration: value`. */
  textDecoration(value: Properties["textDecoration"]) {
    return this.add("textDecoration", value);
  }

  // textTransform
  /** Sets `textTransform: "capitalize"`. */
  get ttc() {
    return this.add("textTransform", "capitalize");
  }
  /** Sets `textTransform: "lowercase"`. */
  get ttl() {
    return this.add("textTransform", "lowercase");
  }
  /** Sets `textTransform: "uppercase"`. */
  get ttu() {
    return this.add("textTransform", "uppercase");
  }
  /** Sets `textTransform: "none"`. */
  get ttn() {
    return this.add("textTransform", "none");
  }
  /** Sets `textTransform: value`. */
  tt(value: Properties["textTransform"]) {
    return this.add("textTransform", value);
  }

  // typeScale
  /** Sets `fontWeight: 400; fontSize: "32px"; lineHeight: "1.10em"; fontFamily: "'Good Sans'"; letterSpacing: "-0.05em"`. */
  get t32() {
    return this.add("fontWeight", 400).add("fontSize", "32px").add("lineHeight", "1.10em").add(
      "fontFamily",
      "'Good Sans'",
    ).add("letterSpacing", "-0.05em");
  }
  /** Sets `fontWeight: 400; fontSize: "24px"; lineHeight: "1.10em"; fontFamily: "'Good Sans'"; letterSpacing: "-0.05em"`. */
  get t24() {
    return this.add("fontWeight", 400).add("fontSize", "24px").add("lineHeight", "1.10em").add(
      "fontFamily",
      "'Good Sans'",
    ).add("letterSpacing", "-0.05em");
  }
  /** Sets `fontWeight: 400; fontSize: "18px"; lineHeight: "1.10em"; fontFamily: "'Good Sans'"; letterSpacing: "-0.04em"`. */
  get t18() {
    return this.add("fontWeight", 400).add("fontSize", "18px").add("lineHeight", "1.10em").add(
      "fontFamily",
      "'Good Sans'",
    ).add("letterSpacing", "-0.04em");
  }
  /** Sets `fontWeight: 200; fontSize: "16px"; lineHeight: "1.10em"; fontFamily: "'Good Sans'"; letterSpacing: "-0.02em"`. */
  get t16() {
    return this.add("fontWeight", 200).add("fontSize", "16px").add("lineHeight", "1.10em").add(
      "fontFamily",
      "'Good Sans'",
    ).add("letterSpacing", "-0.02em");
  }
  /** Sets `fontWeight: 200; fontSize: "14px"; lineHeight: "1.25em"; fontFamily: "'Good Sans'"; letterSpacing: "-0.02em"`. */
  get t14() {
    return this.add("fontWeight", 200).add("fontSize", "14px").add("lineHeight", "1.25em").add(
      "fontFamily",
      "'Good Sans'",
    ).add("letterSpacing", "-0.02em");
  }
  /** Sets `fontFamily: "'Good Sans'"; fontSize: "12px"; fontWeight: 300; lineHeight: "1.4em"; letterSpacing: "-0.02em"`. */
  get t12() {
    return this.add("fontFamily", "'Good Sans'").add("fontSize", "12px").add("fontWeight", 300).add(
      "lineHeight",
      "1.4em",
    ).add("letterSpacing", "-0.02em");
  }
  /** Sets `fontFamily: "'Good Sans'"; fontSize: "10px"; lineHeight: "1.25em"; fontWeight: 400; letterSpacing: "-0.005em"`. */
  get t10() {
    return this.add("fontFamily", "'Good Sans'").add("fontSize", "10px").add("lineHeight", "1.25em").add(
      "fontWeight",
      400,
    ).add("letterSpacing", "-0.005em");
  }

  // typography
  /** Sets `maxWidth: "30em"`. */
  get measure() {
    return this.add("maxWidth", "30em");
  }
  /** Sets `maxWidth: "34em"`. */
  get measureWide() {
    return this.add("maxWidth", "34em");
  }
  /** Sets `maxWidth: "20em"`. */
  get measureNarrow() {
    return this.add("maxWidth", "20em");
  }
  /** Sets `textIndent: "1em"; marginTop: 0; marginBottom: 0`. */
  get indent() {
    return this.add("textIndent", "1em").add("marginTop", 0).add("marginBottom", 0);
  }
  /** Sets `fontVariant: "small-caps"`. */
  get smallCaps() {
    return this.add("fontVariant", "small-caps");
  }
  /** Sets `whiteSpace: "nowrap"; overflow: "hidden"; textOverflow: "ellipsis"`. */
  get truncate() {
    return this.add("whiteSpace", "nowrap").add("overflow", "hidden").add("textOverflow", "ellipsis");
  }
  /** Sets `fontSize: value`. */
  fs(value: Properties["fontSize"]) {
    return this.add("fontSize", value);
  }
  /** Sets `fontSize: px`. */
  fsPx(px: number) {
    return this.fs(`${px}px`);
  }
  /** Sets `lineHeight: value`. */
  lh(value: Properties["lineHeight"]) {
    return this.add("lineHeight", value);
  }
  /** Sets `lineHeight: px`. */
  lhPx(px: number) {
    return this.lh(`${px}px`);
  }

  // userSelect
  /** Sets `userSelect: "none"`. */
  get usn() {
    return this.add("userSelect", "none");
  }
  /** Sets `userSelect: "text"`. */
  get ust() {
    return this.add("userSelect", "text");
  }
  /** Sets `userSelect: "all"`. */
  get usAll() {
    return this.add("userSelect", "all");
  }
  /** Sets `userSelect: "auto"`. */
  get usAuto() {
    return this.add("userSelect", "auto");
  }
  /** Sets `userSelect: value`. */
  select(value: Properties["userSelect"]) {
    return this.add("userSelect", value);
  }

  // verticalAlign
  /** Sets `verticalAlign: "baseline"`. */
  get vaBaseline() {
    return this.add("verticalAlign", "baseline");
  }
  /** Sets `verticalAlign: "middle"`. */
  get vam() {
    return this.add("verticalAlign", "middle");
  }
  /** Sets `verticalAlign: "top"`. */
  get vat() {
    return this.add("verticalAlign", "top");
  }
  /** Sets `verticalAlign: "bottom"`. */
  get vaBottom() {
    return this.add("verticalAlign", "bottom");
  }
  /** Sets `verticalAlign: value`. */
  va(value: Properties["verticalAlign"]) {
    return this.add("verticalAlign", value);
  }

  // visibility
  /** Sets `visibility: "visible"`. */
  get vv() {
    return this.add("visibility", "visible");
  }
  /** Sets `visibility: "hidden"`. */
  get vh() {
    return this.add("visibility", "hidden");
  }
  /** Sets `visibility: value`. */
  visibility(value: Properties["visibility"]) {
    return this.add("visibility", value);
  }

  // whitespace
  /** Sets `whiteSpace: "pre"`. */
  get wsp() {
    return this.add("whiteSpace", "pre");
  }
  /** Sets `whiteSpace: "normal"`. */
  get wsn() {
    return this.add("whiteSpace", "normal");
  }
  /** Sets `whiteSpace: "nowrap"`. */
  get wsnw() {
    return this.add("whiteSpace", "nowrap");
  }
  /** Sets `whiteSpace: "break-spaces"`. */
  get wsbs() {
    return this.add("whiteSpace", "break-spaces");
  }
  /** Sets `whiteSpace: "pre-wrap"`. */
  get wspw() {
    return this.add("whiteSpace", "pre-wrap");
  }
  /** Sets `whiteSpace: "pre-line"`. */
  get wspl() {
    return this.add("whiteSpace", "pre-line");
  }
  /** Sets `whiteSpace: value`. */
  whiteSpace(value: Properties["whiteSpace"]) {
    return this.add("whiteSpace", value);
  }

  // width
  /** Sets `width: "25%"`. */
  get w25() {
    return this.add("width", "25%");
  }
  /** Sets `width: "50%"`. */
  get w50() {
    return this.add("width", "50%");
  }
  /** Sets `width: "75%"`. */
  get w75() {
    return this.add("width", "75%");
  }
  /** Sets `width: "100%"`. */
  get w100() {
    return this.add("width", "100%");
  }
  /** Sets `width: "fit-content"`. */
  get wfc() {
    return this.add("width", "fit-content");
  }
  /** Sets `width: "max-content"`. */
  get wmaxc() {
    return this.add("width", "max-content");
  }
  /** Sets `width: "min-content"`. */
  get wminc() {
    return this.add("width", "min-content");
  }
  /** Sets `minWidth: 0`. */
  get mw0() {
    return this.add("minWidth", 0);
  }
  /** Sets `minWidth: "25%"`. */
  get mw25() {
    return this.add("minWidth", "25%");
  }
  /** Sets `minWidth: "50%"`. */
  get mw50() {
    return this.add("minWidth", "50%");
  }
  /** Sets `minWidth: "75%"`. */
  get mw75() {
    return this.add("minWidth", "75%");
  }
  /** Sets `minWidth: "100%"`. */
  get mw100() {
    return this.add("minWidth", "100%");
  }
  /** Sets `minWidth: "fit-content"`. */
  get mwfc() {
    return this.add("minWidth", "fit-content");
  }
  /** Sets `minWidth: "min-content"`. */
  get mwminc() {
    return this.add("minWidth", "min-content");
  }
  /** Sets `minWidth: "max-content"`. */
  get mwmaxc() {
    return this.add("minWidth", "max-content");
  }
  /** Sets `minWidth: value`. */
  mw(value: Properties["minWidth"]) {
    return this.add("minWidth", value);
  }
  /** Sets `minWidth: px`. */
  mwPx(px: number) {
    return this.mw(`${px}px`);
  }
  /** Sets `maxWidth: "0"`. */
  get maxw0() {
    return this.add("maxWidth", "0");
  }
  /** Sets `maxWidth: "25%"`. */
  get maxw25() {
    return this.add("maxWidth", "25%");
  }
  /** Sets `maxWidth: "50%"`. */
  get maxw50() {
    return this.add("maxWidth", "50%");
  }
  /** Sets `maxWidth: "75%"`. */
  get maxw75() {
    return this.add("maxWidth", "75%");
  }
  /** Sets `maxWidth: "100%"`. */
  get maxw100() {
    return this.add("maxWidth", "100%");
  }
  /** Sets `maxWidth: "fit-content"`. */
  get maxwfc() {
    return this.add("maxWidth", "fit-content");
  }
  /** Sets `maxWidth: "min-content"`. */
  get maxwminc() {
    return this.add("maxWidth", "min-content");
  }
  /** Sets `maxWidth: "max-content"`. */
  get maxwmaxc() {
    return this.add("maxWidth", "max-content");
  }
  /** Sets `maxWidth: value`. */
  maxw(value: Properties["maxWidth"]) {
    return this.add("maxWidth", value);
  }
  /** Sets `maxWidth: px`. */
  maxwPx(px: number) {
    return this.maxw(`${px}px`);
  }
  /** Sets `width: "0px"`. */
  get w0() {
    return this.add("width", "0px");
  }
  /** Sets `width: "8px"`. */
  get w1() {
    return this.add("width", "8px");
  }
  /** Sets `width: "16px"`. */
  get w2() {
    return this.add("width", "16px");
  }
  /** Sets `width: "24px"`. */
  get w3() {
    return this.add("width", "24px");
  }
  /** Sets `width: "32px"`. */
  get w4() {
    return this.add("width", "32px");
  }
  /** Sets `width: "40px"`. */
  get w5() {
    return this.add("width", "40px");
  }
  /** Sets `width: "48px"`. */
  get w6() {
    return this.add("width", "48px");
  }
  /** Sets `width: "56px"`. */
  get w7() {
    return this.add("width", "56px");
  }
  /** Sets `width: "64px"`. */
  get w8() {
    return this.add("width", "64px");
  }
  /** Sets `width: "auto"`. */
  get wa() {
    return this.add("width", "auto");
  }
  /** Sets `width: "v"`. */
  w(v: number | string) {
    return this.add("width", maybeInc(v));
  }
  /** Sets `width: px`. */
  wPx(px: number) {
    return this.add("width", `${px}px`);
  }

  // wordBreak
  /** Sets `wordBreak: "normal"`. */
  get wbn() {
    return this.add("wordBreak", "normal");
  }
  /** Sets `wordBreak: "break-all"`. */
  get wbba() {
    return this.add("wordBreak", "break-all");
  }
  /** Sets `wordBreak: "keep-all"`. */
  get wbka() {
    return this.add("wordBreak", "keep-all");
  }
  /** Sets `wordBreak: "break-word"`. */
  get wbbw() {
    return this.add("wordBreak", "break-word");
  }
  /** Sets `wordBreak: value`. */
  wordBreak(value: Properties["wordBreak"]) {
    return this.add("wordBreak", value);
  }

  // zIndex
  /** Sets `zIndex: 0`. */
  get z0() {
    return this.add("zIndex", 0);
  }
  /** Sets `zIndex: 1`. */
  get z1() {
    return this.add("zIndex", 1);
  }
  /** Sets `zIndex: 2`. */
  get z2() {
    return this.add("zIndex", 2);
  }
  /** Sets `zIndex: 3`. */
  get z3() {
    return this.add("zIndex", 3);
  }
  /** Sets `zIndex: 4`. */
  get z4() {
    return this.add("zIndex", 4);
  }
  /** Sets `zIndex: 5`. */
  get z5() {
    return this.add("zIndex", 5);
  }
  /** Sets `zIndex: 999`. */
  get z999() {
    return this.add("zIndex", 999);
  }
  /** Sets `zIndex: 9999`. */
  get z9999() {
    return this.add("zIndex", 9999);
  }
  /** Sets `zIndex: "inherit"`. */
  get zInherit() {
    return this.add("zIndex", "inherit");
  }
  /** Sets `zIndex: "initial"`. */
  get zInitial() {
    return this.add("zIndex", "initial");
  }
  /** Sets `zIndex: "unset"`. */
  get zUnset() {
    return this.add("zIndex", "unset");
  }
  /** Sets `zIndex: value`. */
  z(value: Properties["zIndex"]) {
    return this.add("zIndex", value);
  }

  // fontFamily
  /** Sets `fontFamily: "'PT Serif', serif"`. */
  get serif() {
    return this.add("fontFamily", "'PT Serif', serif");
  }
  /** Sets `fontFamily: "'Good Sans', sans serif"`. */
  get sansSerif() {
    return this.add("fontFamily", "'Good Sans', sans serif");
  }

  // transform: translateY
  ty(value: string) {
    return this.add("transform", `translateY(${value})`);
  }

  // transform: translateX
  tx(value: string) {
    return this.add("transform", `translateX(${value})`);
  }

  // pointerEvents
  /** Sets `pointerEvents: "none"`. */
  get pointerNone() {
    return this.add("pointerEvents", "none");
  }

  // listReset
  /** Sets `padding: 0; margin: 0; listStyle: "none"`. */
  get listReset() {
    return this.add("padding", 0).add("margin", 0).add("listStyle", "none");
  }

  // gridExtras
  /** Sets `gridAutoFlow: "column"`. */
  get gafc() {
    return this.add("gridAutoFlow", "column");
  }
  /** Sets `gridAutoFlow: "row"`. */
  get gafr() {
    return this.add("gridAutoFlow", "row");
  }
  /** Sets `gridRowGap: "0px"`. */
  get rowGap0() {
    return this.add("gridRowGap", "0px");
  }
  /** Sets `gridRowGap: "8px"`. */
  get rowGap1() {
    return this.add("gridRowGap", "8px");
  }
  /** Sets `gridRowGap: "16px"`. */
  get rowGap2() {
    return this.add("gridRowGap", "16px");
  }
  /** Sets `gridRowGap: "24px"`. */
  get rowGap3() {
    return this.add("gridRowGap", "24px");
  }
  /** Sets `gridRowGap: "32px"`. */
  get rowGap4() {
    return this.add("gridRowGap", "32px");
  }
  /** Sets `gridRowGap: "40px"`. */
  get rowGap5() {
    return this.add("gridRowGap", "40px");
  }
  /** Sets `gridRowGap: "48px"`. */
  get rowGap6() {
    return this.add("gridRowGap", "48px");
  }
  /** Sets `gridRowGap: "56px"`. */
  get rowGap7() {
    return this.add("gridRowGap", "56px");
  }
  /** Sets `gridRowGap: "64px"`. */
  get rowGap8() {
    return this.add("gridRowGap", "64px");
  }
  /** Sets `gridRowGap: "v"`. */
  rowGap(v: number | string) {
    return this.add("gridRowGap", maybeInc(v));
  }
  /** Sets `gridRowGap: px`. */
  rowGapPx(px: number) {
    return this.add("gridRowGap", `${px}px`);
  }
  /** Sets `gridColumnGap: "0px"`. */
  get colGap0() {
    return this.add("gridColumnGap", "0px");
  }
  /** Sets `gridColumnGap: "8px"`. */
  get colGap1() {
    return this.add("gridColumnGap", "8px");
  }
  /** Sets `gridColumnGap: "16px"`. */
  get colGap2() {
    return this.add("gridColumnGap", "16px");
  }
  /** Sets `gridColumnGap: "24px"`. */
  get colGap3() {
    return this.add("gridColumnGap", "24px");
  }
  /** Sets `gridColumnGap: "32px"`. */
  get colGap4() {
    return this.add("gridColumnGap", "32px");
  }
  /** Sets `gridColumnGap: "40px"`. */
  get colGap5() {
    return this.add("gridColumnGap", "40px");
  }
  /** Sets `gridColumnGap: "48px"`. */
  get colGap6() {
    return this.add("gridColumnGap", "48px");
  }
  /** Sets `gridColumnGap: "56px"`. */
  get colGap7() {
    return this.add("gridColumnGap", "56px");
  }
  /** Sets `gridColumnGap: "64px"`. */
  get colGap8() {
    return this.add("gridColumnGap", "64px");
  }
  /** Sets `gridColumnGap: "v"`. */
  colGap(v: number | string) {
    return this.add("gridColumnGap", maybeInc(v));
  }
  /** Sets `gridColumnGap: px`. */
  colGapPx(px: number) {
    return this.add("gridColumnGap", `${px}px`);
  }

  // widthExtras
  /** Sets `width: "fit-content"`. */
  get wFit() {
    return this.add("width", "fit-content");
  }
  /** Sets `width: "100%"; maxWidth: "1440px"`. */
  get maxContainer() {
    return this.add("width", "100%").add("maxWidth", "1440px");
  }

  // containerQueries

  /**
   * Sets the selected element as a container query target with `inline-size`
   *
   * @param name - The name of the container.
   * @param containerType - The `containerType` if different than `inline-size`.
   */
  container({ name, containerType }: { name?: string; containerType?: "inline-size" } = {}): CssBuilder<T> {
    return this.add({ containerType: containerType ?? "inline-size", ...(name && { containerName: name }) });
  }

  // aspectRatio
  /** Sets `aspectRatio: value`. */
  ar(value: Properties["aspectRatio"]) {
    return this.add("aspectRatio", value);
  }

  // borderNone
  /** Sets `border: "none"`. */
  get bNone() {
    return this.add("border", "none");
  }
  /** Sets `borderTop: "none"`. */
  get btNone() {
    return this.add("borderTop", "none");
  }
  /** Sets `borderRight: "none"`. */
  get brNone() {
    return this.add("borderRight", "none");
  }
  /** Sets `borderBottom: "none"`. */
  get bbNone() {
    return this.add("borderBottom", "none");
  }
  /** Sets `borderLeft: "none"`. */
  get blNone() {
    return this.add("borderLeft", "none");
  }
  /** Sets `borderLeft: "none"; borderRight: "none"`. */
  get bxNone() {
    return this.add("borderLeft", "none").add("borderRight", "none");
  }
  /** Sets `borderTop: "none"; borderBottom: "none"`. */
  get byNone() {
    return this.add("borderTop", "none").add("borderBottom", "none");
  }

  // textUnderlineOffset
  /** Sets `textUnderlineOffset: "2px"`. */
  get tuoSmall() {
    return this.add("textUnderlineOffset", "2px");
  }
  /** Sets `textUnderlineOffset: "3px"`. */
  get tuoMedium() {
    return this.add("textUnderlineOffset", "3px");
  }
  /** Sets `textUnderlineOffset: "4px"`. */
  get tuoLarge() {
    return this.add("textUnderlineOffset", "4px");
  }

  // tuo
  /** Sets `textUnderlineOffset: value`. */
  tuo(value: Properties["textUnderlineOffset"]) {
    return this.add("textUnderlineOffset", value);
  }

  // tdc
  /** Sets `textDecorationColor: value`. */
  tdc(value: Properties["textDecorationColor"]) {
    return this.add("textDecorationColor", value);
  }

  // tdt
  /** Sets `textDecorationThickness: value`. */
  tdt(value: Properties["textDecorationThickness"]) {
    return this.add("textDecorationThickness", value);
  }

  // borderLeftColor
  /** Sets `borderLeftColor: value`. */
  blc(value: Properties["borderLeftColor"]) {
    return this.add("borderLeftColor", value);
  }

  // borderRightColor
  /** Sets `borderRightColor: value`. */
  brc(value: Properties["borderRightColor"]) {
    return this.add("borderRightColor", value);
  }

  // italic
  /** Sets `fontStyle: "italic"`. */
  get italic() {
    return this.add("fontStyle", "italic");
  }

  // hideScrollBar
  /** Sets `overflow: "auto"; scrollbarWidth: "none"; msOverflowStyle: "none"`. */
  get oahs() {
    return this.add("overflow", "auto").add("scrollbarWidth", "none").add("msOverflowStyle", "none");
  }

  // aliases

  get $(): T {
    return maybeImportant(sortObject(this.rules), this.opts.important);
  }

  if(bp: Breakpoint): CssBuilder<T>;
  if(cond: boolean): CssBuilder<T>;
  if(attr: string, value: boolean | string): CssBuilder<T>;
  if(arg: boolean | Breakpoint | string, value?: boolean | string): CssBuilder<T> {
    if (value !== undefined) {
      return this.newCss({ selector: `[${arg}='${value}']` });
    } else if (typeof arg === "boolean") {
      return this.newCss({ enabled: arg });
    } else {
      return this.newCss({ selector: Breakpoints[arg as Breakpoint] });
    }
  }

  get onHover() {
    return this.newCss({ selector: ":hover" });
  }

  ifContainer(props: ContainerProps) {
    return this.newCss({ selector: Container(props) });
  }

  get ifPrint() {
    return this.newCss({ selector: "@media print" });
  }
  get ifMobile() {
    return this.newCss({ selector: "@media screen and (max-width:767px)" });
  }
  get ifTablet() {
    return this.newCss({ selector: "@media screen and (min-width:768px) and (max-width:1023px)" });
  }
  get ifMobileOrTablet() {
    return this.newCss({ selector: "@media screen and (max-width:1023px)" });
  }
  get ifTabletAndUp() {
    return this.newCss({ selector: "@media screen and (min-width:768px)" });
  }
  get ifTabletAndDown() {
    return this.newCss({ selector: "@media screen and (max-width:1023px)" });
  }
  get ifDesktop() {
    return this.newCss({ selector: "@media screen and (min-width:1024px) and (max-width:1279px)" });
  }
  get ifTabletOrDesktop() {
    return this.newCss({ selector: "@media screen and (min-width:768px) and (max-width:1279px)" });
  }
  get ifDesktopAndUp() {
    return this.newCss({ selector: "@media screen and (min-width:1024px)" });
  }
  get ifDesktopAndDown() {
    return this.newCss({ selector: "@media screen and (max-width:1279px)" });
  }
  get ifLgDesktop() {
    return this.newCss({ selector: "@media screen and (min-width:1280px) and (max-width:1583px)" });
  }
  get ifDesktopOrLgDesktop() {
    return this.newCss({ selector: "@media screen and (min-width:1024px) and (max-width:1583px)" });
  }
  get ifLgDesktopAndUp() {
    return this.newCss({ selector: "@media screen and (min-width:1280px)" });
  }
  get ifLgDesktopAndDown() {
    return this.newCss({ selector: "@media screen and (max-width:1583px)" });
  }
  get ifXl() {
    return this.newCss({ selector: "@media screen and (min-width:1584px) and (max-width:1784px)" });
  }
  get ifLgDesktopOrXl() {
    return this.newCss({ selector: "@media screen and (min-width:1280px) and (max-width:1784px)" });
  }
  get ifXlAndUp() {
    return this.newCss({ selector: "@media screen and (min-width:1584px)" });
  }
  get ifXlAndDown() {
    return this.newCss({ selector: "@media screen and (max-width:1784px)" });
  }
  get ifMax() {
    return this.newCss({ selector: "@media screen and (min-width:1785px)" });
  }
  get ifXlOrMax() {
    return this.newCss({ selector: "@media screen and (min-width:1584px)" });
  }

  get else() {
    if (this.selector !== undefined) {
      if (this.selector.includes("not")) {
        throw new Error("else was already called");
      } else {
        return this.newCss({ selector: this.selector.replace("@media", "@media not") });
      }
    }
    return this.newCss({ enabled: !this.enabled });
  }

  get important() {
    return this.newCss({ important: true });
  }

  /** Adds new properties, either a specific key/value or a Properties object, to the current css. */
  add<P extends Properties>(props: P): CssBuilder<T & P>;
  add<K extends keyof Properties>(prop: K, value: Properties[K]): CssBuilder<T & { [U in K]: Properties[K] }>;
  add<K extends keyof Properties>(propOrProperties: K | Properties, value?: Properties[K]): CssBuilder<any> {
    if (!this.enabled) {
      return this;
    }
    const newRules = typeof propOrProperties === "string" ? { [propOrProperties]: value } : propOrProperties;
    const rules = this.selector
      ? { ...this.rules, [this.selector]: { ...(this.rules as any)[this.selector], ...newRules } }
      : { ...this.rules, ...newRules };
    return this.newCss({ rules: rules as any });
  }

  /** Adds new properties, either a specific key/value or a Properties object, to a nested selector. */
  addIn<P extends Properties>(selector: string, props: P | undefined): CssBuilder<T & P>;
  addIn<K extends keyof Properties>(
    selector: string,
    prop: K,
    value: Properties[K],
  ): CssBuilder<T & { [U in K]: Properties[K] }>;
  addIn<K extends keyof Properties>(
    selector: string,
    propOrProperties: K | Properties,
    value?: Properties[K],
  ): CssBuilder<any> {
    const newRules = typeof propOrProperties === "string" ? { [propOrProperties]: value } : propOrProperties;
    if (!this.enabled) {
      return this;
    }
    if (newRules === undefined) {
      return this;
    }
    const rules = { ...this.rules, [selector]: { ...(this.rules as any)[selector], ...newRules } };
    return this.newCss({ rules: rules as any });
  }
}

/** Emotion treats the same rules, ordered differently as different classes, but naively they can be the same. */
function sortObject<T extends object>(obj: T): T {
  return Object.keys(obj).sort().reduce((acc, key) => {
    acc[key as keyof T] = obj[key as keyof T];
    return acc;
  }, ({} as any) as T) as T;
}

/** Conditionally adds `important!` to everything. */
function maybeImportant<T extends object>(obj: T, important: boolean): T {
  if (important) {
    Object.keys(obj).forEach((key) => {
      (obj as any)[key] = `${(obj as any)[key]} !important`;
    });
  }
  return obj;
}

/** Converts `inc` into pixels value with a `px` suffix. */
export function maybeInc(inc: number | string): string {
  return typeof inc === "string" ? inc : `${increment(inc)}px`;
}

/** Converts `inc` into pixels. */
export function increment(inc: number): number {
  return inc * 8;
}

/** Convert `pixels` to a `px` units string so it's not ambiguous. */
export function px(pixels: number): string {
  return `${pixels}px`;
}

export enum Palette {
  White = "#FFFFFF",
  OffWhite = "#F6F6F0",
  Black = "#000000",
  bpBlue = "#0067C5",
  Taupe = "#EBEAE4FF",
  Gray = "#888888",
  Transparent = "#00000000",
  TranslucentBlack = "#000000B2",
  BrightYellow = "#F6B14E",
  BrightGreen = "#AEB564",
  BrightBlue = "#3A759D",
  BrightStrawberry = "#C86251",
  SaturatedWine = "#8B514E",
  SaturatedOrange = "#D17520",
  SaturatedGrass = "#657839",
  Moss = "#9CA084",
  Plum = "#5F477F",
  LightGray = "#CECECE",
  MidGray = "#66666DFF",
  LightBlue = "#D2D7DD",
  LightPeach = "#F7E9D5",
  Gray80 = "#353535CC",
  Gray4 = "#3535350A",
  Gray8 = "#35353514",
  Gray16 = "#35353529",
  Gray50 = "#fffdfd",
  Gray100 = "#F7F5F5",
  Gray200 = "#ECEBEB",
  Gray300 = "#DDDCDC",
  Gray400 = "#C9C9C9",
  Gray500 = "#AFAFAF",
  Gray600 = "#8D8D8D",
  Gray700 = "#646464",
  Gray800 = "#353535",
  Gray900 = "#242424",
  Green50 = "#ecfdf5",
  Green100 = "#d1fae5",
  Green200 = "#a7f3d0",
  Green300 = "#6ee7b7",
  Green400 = "#34d399",
  Green500 = "#10b981",
  Green600 = "#059669",
  Green700 = "#047857",
  Green800 = "#065f46",
  Green900 = "#064e3b",
  Purple50 = "#f5f3ff",
  Purple100 = "#ede9fe",
  Purple200 = "#ddd6fe",
  Purple300 = "#c4b5fd",
  Purple400 = "#a78bfa",
  Purple500 = "#8b5cf6",
  Purple600 = "#7c3aed",
  Purple700 = "#6d28d9",
  Purple800 = "#5b21b6",
  Purple900 = "#4c1d95",
  RedError = "#DA1E28",
  Red50 = "#fef2f2",
  Red100 = "#fee2e2",
  Red200 = "#fecaca",
  Red300 = "#fca5a5",
  Red400 = "#f87171",
  Red500 = "#ef4444",
  Red600 = "#c86251",
  Red700 = "#b91c1c",
  Red800 = "#991b1b",
  Red900 = "#7f1d1d",
  Yellow50 = "#fefce8",
  Yellow100 = "#fef9c3",
  Yellow200 = "#fef08a",
  Yellow300 = "#fde047",
  Yellow400 = "#facc15",
  Yellow500 = "#eab308",
  Yellow600 = "#ca8a04",
  Yellow700 = "#a16207",
  Yellow800 = "#854d0e",
  Yellow900 = "#713f12",
  Blue50 = "#eff6ff",
  Blue100 = "#dbeafe",
  Blue200 = "#bfdbfe",
  Blue300 = "#93c5fd",
  Blue400 = "#60a5fa",
  Blue500 = "#3b82f6",
  Blue600 = "#2563eb",
  Blue700 = "#1d4ed8",
  Blue800 = "#1e40af",
  Blue900 = "#1e3a8a",
  Orange50 = "#fff7ed",
  Orange100 = "#ffedd5",
  Orange200 = "#fed7aa",
  Orange300 = "#fdba74",
  Orange400 = "#fb923c",
  Orange500 = "#f97316",
  Orange600 = "#ea580c",
  Orange700 = "#c2410c",
  Orange800 = "#9a3412",
  Orange900 = "#7c2d12",
}

/** A shortcut for defining Xss types. */
export type Xss<P extends keyof Properties> = Pick<Properties, P>;

/** An entry point for Css expressions. CssBuilder is immutable so this is safe to share. */
export const Css = new CssBuilder({ rules: {}, enabled: true, important: false, selector: undefined });

export type Margin = "margin" | "marginTop" | "marginRight" | "marginBottom" | "marginLeft";

export type Padding = "padding" | "paddingTop" | "paddingRight" | "paddingBottom" | "paddingLeft";

export type Breakpoint =
  | "print"
  | "mobile"
  | "tablet"
  | "mobileOrTablet"
  | "tabletAndUp"
  | "tabletAndDown"
  | "desktop"
  | "tabletOrDesktop"
  | "desktopAndUp"
  | "desktopAndDown"
  | "lgDesktop"
  | "desktopOrLgDesktop"
  | "lgDesktopAndUp"
  | "lgDesktopAndDown"
  | "xl"
  | "lgDesktopOrXl"
  | "xlAndUp"
  | "xlAndDown"
  | "max"
  | "xlOrMax";
export enum Breakpoints {
  print = "@media print",
  mobile = "@media screen and (max-width:767px)",
  tablet = "@media screen and (min-width:768px) and (max-width:1023px)",
  mobileOrTablet = "@media screen and (max-width:1023px)",
  tabletAndUp = "@media screen and (min-width:768px)",
  tabletAndDown = "@media screen and (max-width:1023px)",
  desktop = "@media screen and (min-width:1024px) and (max-width:1279px)",
  tabletOrDesktop = "@media screen and (min-width:768px) and (max-width:1279px)",
  desktopAndUp = "@media screen and (min-width:1024px)",
  desktopAndDown = "@media screen and (max-width:1279px)",
  lgDesktop = "@media screen and (min-width:1280px) and (max-width:1583px)",
  desktopOrLgDesktop = "@media screen and (min-width:1024px) and (max-width:1583px)",
  lgDesktopAndUp = "@media screen and (min-width:1280px)",
  lgDesktopAndDown = "@media screen and (max-width:1583px)",
  xl = "@media screen and (min-width:1584px) and (max-width:1784px)",
  lgDesktopOrXl = "@media screen and (min-width:1280px) and (max-width:1784px)",
  xlAndUp = "@media screen and (min-width:1584px)",
  xlAndDown = "@media screen and (max-width:1784px)",
  max = "@media screen and (min-width:1785px)",
  xlOrMax = "@media screen and (min-width:1584px)",
}

/**
 * Utility to help write `@container` queries
 *
 * @param name - The name of the container.
 * @param lt - The maximum width of the container inclusive.
 * @param gt - The minimum width of the container exclusive.
 */
type ContainerProps = { name?: string } & ({ lt: number } | { gt: number } | { lt: number; gt: number });
export function Container(props: ContainerProps) {
  const { name = "" } = props;
  const lt = "lt" in props ? props.lt : undefined;
  const gt = "gt" in props ? props.gt : undefined;

  const ltQuery = lt !== undefined ? `(max-width: ${lt}px)` : "";
  const gtQuery = gt !== undefined ? `(min-width: ${gt + 1}px)` : "";
  const query = [ltQuery, gtQuery].filter(Boolean).join(" and ");

  return `@container ${name} ${query}`;
}
